import React from "react";

function IconPlay(props) {
  const fill = props.fill || "#6236FF";
  return (
    <svg
      width="50"
      height="33"
      viewBox="0 0 50 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect y="0.155243" width="50" height="32" rx="16" fill={fill} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 10.1552L22 22.1552L32 16.1552L22 10.1552Z"
        fill="white"
      />
    </svg>
  );
}

function RightArrow(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 13H16.17L12.29 16.88C11.9 17.27 11.9 17.91 12.29 18.3C12.68 18.69 13.31 18.69 13.7 18.3L19.29 12.71C19.68 12.32 19.68 11.69 19.29 11.3L13.71 5.7C13.32 5.31 12.69 5.31 12.3 5.7C11.91 6.09 11.91 6.72 12.3 7.11L16.17 11H5C4.45 11 4 11.45 4 12C4 12.55 4.45 13 5 13Z"
        fill={fill}
      />
    </svg>
  );
}

function FlashRounded(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.02C6.48999 2.02 2.01999 6.49 2.01999 12C2.01999 17.51 6.48999 21.98 12 21.98C17.51 21.98 21.98 17.51 21.98 12C21.98 6.49 17.51 2.02 12 2.02ZM11.48 17.88V13.74H8.81999C8.44999 13.74 8.19999 13.34 8.37999 13.01L12.06 5.84C12.29 5.37 13 5.54 13 6.07V10.26H15.54C15.91 10.26 16.15 10.65 15.99 10.98L12.43 18.1C12.19 18.58 11.48 18.41 11.48 17.88Z"
        fill={fill}
      />
    </svg>
  );
}

function SimpleRightArrow(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.09121 14.4169C8.41621 14.7419 8.94121 14.7419 9.26621 14.4169L13.0912 10.5919C13.4162 10.2669 13.4162 9.74189 13.0912 9.41689L9.26621 5.5919C8.94121 5.2669 8.41621 5.2669 8.09121 5.5919C7.76621 5.91689 7.76621 6.44189 8.09121 6.76689L11.3245 10.0086L8.09121 13.2419C7.76621 13.5669 7.77454 14.1002 8.09121 14.4169Z"
        fill={fill}
      />
    </svg>
  );
}

function SprocketLogotypeLight(props) {
  return (
    <svg
      width="140px"
      height="35px"
      viewBox="0 0 140 35"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Sprocket Branding" fillRule="nonzero">
        <path
          d="M34.4757282,25.1699029 C35.3592233,25.1699029 36.157767,25.039644 36.8713592,24.7791262 C37.5849515,24.5186084 38.1909385,24.1731392 38.6893204,23.7427184 C39.1877023,23.3122977 39.5728155,22.8082524 39.8446602,22.2305825 C40.1165049,21.6529126 40.2524272,21.0469256 40.2524272,20.4126214 C40.2524272,19.4838188 40.0542071,18.7305825 39.657767,18.1529126 C39.2613269,17.5752427 38.7686084,17.105178 38.1796117,16.7427184 C37.5906149,16.3802589 36.9506472,16.1027508 36.2597087,15.9101942 C35.5687702,15.7176375 34.9288026,15.5364078 34.3398058,15.3665049 C33.7508091,15.1966019 33.2580906,15.0097087 32.8616505,14.8058252 C32.4652104,14.6019417 32.2669903,14.3187702 32.2669903,13.9563107 C32.2669903,13.52589 32.4312298,13.1634304 32.7597087,12.868932 C33.0881877,12.5744337 33.5469256,12.4271845 34.1359223,12.4271845 C34.7249191,12.4271845 35.2176375,12.5970874 35.6140777,12.9368932 C36.0105178,13.276699 36.2540453,13.6165049 36.3446602,13.9563107 L36.3446602,13.9563107 L40.0825243,13.9563107 C39.9012945,12.5970874 39.3066343,11.4644013 38.2985437,10.5582524 C37.2904531,9.65210356 35.8462783,9.19902913 33.9660194,9.19902913 C33.105178,9.19902913 32.3349515,9.32928803 31.6553398,9.58980583 C30.9757282,9.85032362 30.3867314,10.1957929 29.8883495,10.6262136 C29.3899676,11.0566343 29.0105178,11.5606796 28.75,12.1383495 C28.4894822,12.7160194 28.3592233,13.3220065 28.3592233,13.9563107 C28.3592233,14.8624595 28.5574434,15.5930421 28.9538835,16.1480583 C29.3503236,16.7030744 29.8430421,17.1561489 30.4320388,17.5072816 C31.0210356,17.8584142 31.6610032,18.1245955 32.3519417,18.3058252 C33.0428803,18.487055 33.6828479,18.6626214 34.2718447,18.8325243 C34.8608414,19.0024272 35.3535599,19.1893204 35.75,19.3932039 C36.1464401,19.5970874 36.3446602,19.8802589 36.3446602,20.2427184 C36.3446602,20.6731392 36.1464401,21.0639159 35.75,21.4150485 C35.3535599,21.7661812 34.815534,21.9417476 34.1359223,21.9417476 C33.4563107,21.9417476 32.9126214,21.7605178 32.5048544,21.3980583 C32.0970874,21.0355987 31.8478964,20.5938511 31.7572816,20.0728155 L31.7572816,20.0728155 L28.0194175,20.0728155 C28.1779935,21.6132686 28.7839806,22.8478964 29.8373786,23.776699 C30.8907767,24.7055016 32.4368932,25.1699029 34.4757282,25.1699029 Z M45.6893204,30.4368932 L45.6893204,23.6407767 C46.0064725,23.9352751 46.368932,24.1957929 46.776699,24.4223301 C47.1391586,24.6035599 47.5639159,24.7734628 48.0509709,24.9320388 C48.5380259,25.0906149 49.1100324,25.1699029 49.7669903,25.1699029 C50.7411003,25.1699029 51.6699029,24.9716828 52.5533981,24.5752427 C53.4368932,24.1788026 54.2127832,23.6237864 54.881068,22.9101942 C55.5493528,22.1966019 56.0817152,21.3527508 56.4781553,20.3786408 C56.8745955,19.4045307 57.0728155,18.3398058 57.0728155,17.184466 C57.0728155,16.0291262 56.8745955,14.9644013 56.4781553,13.9902913 C56.0817152,13.0161812 55.5493528,12.1723301 54.881068,11.4587379 C54.2127832,10.7451456 53.4368932,10.1901294 52.5533981,9.79368932 C51.6699029,9.39724919 50.7411003,9.19902913 49.7669903,9.19902913 C49.0873786,9.19902913 48.4757282,9.28964401 47.9320388,9.47087379 C47.3883495,9.65210356 46.9239482,9.84466019 46.538835,10.0485437 C46.0857605,10.2977346 45.6893204,10.5809061 45.3495146,10.8980583 L45.3495146,10.8980583 L44.6699029,9.36893204 L41.7815534,9.36893204 L41.7815534,30.4368932 L45.6893204,30.4368932 Z M49.2572816,21.4320388 C48.1472492,21.4320388 47.2184466,21.0469256 46.4708738,20.276699 C45.723301,19.5064725 45.3495146,18.4757282 45.3495146,17.184466 C45.3495146,15.8932039 45.723301,14.8624595 46.4708738,14.092233 C47.2184466,13.3220065 48.1472492,12.9368932 49.2572816,12.9368932 C50.3673139,12.9368932 51.2961165,13.3220065 52.0436893,14.092233 C52.7912621,14.8624595 53.1650485,15.8932039 53.1650485,17.184466 C53.1650485,18.4757282 52.7912621,19.5064725 52.0436893,20.276699 C51.2961165,21.0469256 50.3673139,21.4320388 49.2572816,21.4320388 Z M62.5097087,25 L62.5097087,16.6747573 C62.5097087,15.6553398 62.8098706,14.8341424 63.4101942,14.211165 C64.0105178,13.5881877 64.7864078,13.276699 65.7378641,13.276699 C65.9417476,13.276699 66.1286408,13.2880259 66.2985437,13.3106796 C66.4684466,13.3333333 66.6100324,13.3559871 66.723301,13.3786408 C66.8592233,13.4012945 66.9838188,13.4239482 67.0970874,13.4466019 L67.0970874,13.4466019 L67.0970874,9.36893204 L67.0970874,9.36893204 L66.7572816,9.30097087 C66.6440129,9.27831715 66.5194175,9.25566343 66.3834951,9.23300971 C66.2475728,9.21035599 66.0889968,9.19902913 65.907767,9.19902913 C65.3187702,9.19902913 64.7920712,9.29530744 64.3276699,9.48786408 C63.8632686,9.68042071 63.4724919,9.9012945 63.1553398,10.1504854 C62.7702265,10.4223301 62.4417476,10.7281553 62.1699029,11.0679612 L62.1699029,11.0679612 L61.4902913,9.36893204 L58.6019417,9.36893204 L58.6019417,25 L62.5097087,25 Z M75.0825243,25.1699029 C76.1472492,25.1699029 77.1496764,24.960356 78.0898058,24.5412621 C79.0299353,24.1221683 79.8567961,23.5501618 80.5703883,22.8252427 C81.2839806,22.1003236 81.8503236,21.2564725 82.2694175,20.2936893 C82.6885113,19.3309061 82.8980583,18.2944984 82.8980583,17.184466 C82.8980583,16.0744337 82.6885113,15.0380259 82.2694175,14.0752427 C81.8503236,13.1124595 81.2839806,12.2686084 80.5703883,11.5436893 C79.8567961,10.8187702 79.0299353,10.2467638 78.0898058,9.8276699 C77.1496764,9.40857605 76.1472492,9.19902913 75.0825243,9.19902913 C74.0177994,9.19902913 73.0153722,9.40857605 72.0752427,9.8276699 C71.1351133,10.2467638 70.3082524,10.8187702 69.5946602,11.5436893 C68.881068,12.2686084 68.3147249,13.1124595 67.8956311,14.0752427 C67.4765372,15.0380259 67.2669903,16.0744337 67.2669903,17.184466 C67.2669903,18.2944984 67.4765372,19.3309061 67.8956311,20.2936893 C68.3147249,21.2564725 68.881068,22.1003236 69.5946602,22.8252427 C70.3082524,23.5501618 71.1351133,24.1221683 72.0752427,24.5412621 C73.0153722,24.960356 74.0177994,25.1699029 75.0825243,25.1699029 Z M75.0825243,21.4320388 C73.9724919,21.4320388 73.0436893,21.0469256 72.2961165,20.276699 C71.5485437,19.5064725 71.1747573,18.4757282 71.1747573,17.184466 C71.1747573,15.8932039 71.5485437,14.8624595 72.2961165,14.092233 C73.0436893,13.3220065 73.9724919,12.9368932 75.0825243,12.9368932 C76.1925566,12.9368932 77.1213592,13.3220065 77.868932,14.092233 C78.6165049,14.8624595 78.9902913,15.8932039 78.9902913,17.184466 C78.9902913,18.4757282 78.6165049,19.5064725 77.868932,20.276699 C77.1213592,21.0469256 76.1925566,21.4320388 75.0825243,21.4320388 Z M91.3932039,25.1699029 C92.3220065,25.1699029 93.1941748,25.0056634 94.0097087,24.6771845 C94.8252427,24.3487055 95.5501618,23.9069579 96.184466,23.3519417 C96.8187702,22.7969256 97.3511327,22.1626214 97.7815534,21.4490291 C98.2119741,20.7354369 98.5177994,19.9935275 98.6990291,19.223301 L98.6990291,19.223301 L94.7912621,19.223301 C94.6100324,19.6537217 94.3608414,20.0275081 94.0436893,20.3446602 C93.7718447,20.6165049 93.420712,20.8656958 92.9902913,21.092233 C92.5598706,21.3187702 92.0275081,21.4320388 91.3932039,21.4320388 C90.2831715,21.4320388 89.3543689,21.0469256 88.6067961,20.276699 C87.8592233,19.5064725 87.4854369,18.4757282 87.4854369,17.184466 C87.4854369,15.8932039 87.8592233,14.8624595 88.6067961,14.092233 C89.3543689,13.3220065 90.2831715,12.9368932 91.3932039,12.9368932 C92.0275081,12.9368932 92.5598706,13.0558252 92.9902913,13.2936893 C93.420712,13.5315534 93.7718447,13.7864078 94.0436893,14.0582524 C94.3608414,14.3754045 94.6100324,14.7378641 94.7912621,15.1456311 L94.7912621,15.1456311 L98.6990291,15.1456311 C98.5177994,14.3754045 98.2119741,13.6334951 97.7815534,12.9199029 C97.3511327,12.2063107 96.8187702,11.5720065 96.184466,11.0169903 C95.5501618,10.4619741 94.8252427,10.0202265 94.0097087,9.69174757 C93.1941748,9.36326861 92.3220065,9.19902913 91.3932039,9.19902913 C90.328479,9.19902913 89.3260518,9.40857605 88.3859223,9.8276699 C87.4457929,10.2467638 86.618932,10.8187702 85.9053398,11.5436893 C85.1917476,12.2686084 84.6254045,13.1124595 84.2063107,14.0752427 C83.7872168,15.0380259 83.5776699,16.0744337 83.5776699,17.184466 C83.5776699,18.2944984 83.7872168,19.3309061 84.2063107,20.2936893 C84.6254045,21.2564725 85.1917476,22.1003236 85.9053398,22.8252427 C86.618932,23.5501618 87.4457929,24.1221683 88.3859223,24.5412621 C89.3260518,24.960356 90.328479,25.1699029 91.3932039,25.1699029 Z M103.966019,25 L103.966019,17.8640777 L109.402913,25 L113.820388,25 L107.533981,16.8446602 L113.140777,9.36893204 L108.723301,9.36893204 L103.966019,15.8252427 L103.966019,3.59223301 L100.058252,3.59223301 L100.058252,25 L103.966019,25 Z M120.616505,25.1699029 C121.5,25.1699029 122.321197,25.0226537 123.080097,24.7281553 C123.838997,24.433657 124.518608,24.0542071 125.118932,23.5898058 C125.719256,23.1254045 126.228964,22.5987055 126.648058,22.0097087 C127.067152,21.420712 127.378641,20.8317152 127.582524,20.2427184 L127.582524,20.2427184 L123.504854,20.2427184 C123.323625,20.4692557 123.097087,20.6731392 122.825243,20.8543689 C122.576052,21.012945 122.27589,21.1488673 121.924757,21.2621359 C121.573625,21.3754045 121.13754,21.4320388 120.616505,21.4320388 C119.597087,21.4320388 118.79288,21.171521 118.203883,20.6504854 C117.614887,20.1294498 117.229773,19.4838188 117.048544,18.7135922 L117.048544,18.7135922 L127.92233,18.7135922 C127.944984,18.5550162 127.967638,18.3851133 127.990291,18.2038835 C128.012945,18.0453074 128.035599,17.881068 128.058252,17.711165 C128.080906,17.5412621 128.092233,17.3656958 128.092233,17.184466 C128.092233,16.0064725 127.894013,14.9247573 127.497573,13.9393204 C127.101133,12.9538835 126.563107,12.1100324 125.883495,11.407767 C125.203883,10.7055016 124.411003,10.1618123 123.504854,9.77669903 C122.598706,9.39158576 121.635922,9.19902913 120.616505,9.19902913 C119.55178,9.19902913 118.549353,9.40857605 117.609223,9.8276699 C116.669094,10.2467638 115.842233,10.8187702 115.128641,11.5436893 C114.415049,12.2686084 113.848706,13.1124595 113.429612,14.0752427 C113.010518,15.0380259 112.800971,16.0744337 112.800971,17.184466 C112.800971,18.2944984 113.010518,19.3309061 113.429612,20.2936893 C113.848706,21.2564725 114.415049,22.1003236 115.128641,22.8252427 C115.842233,23.5501618 116.669094,24.1221683 117.609223,24.5412621 C118.549353,24.960356 119.55178,25.1699029 120.616505,25.1699029 Z M124.354369,15.9951456 L116.878641,15.9951456 C117.059871,15.1343042 117.473301,14.4093851 118.118932,13.8203883 C118.764563,13.2313916 119.597087,12.9368932 120.616505,12.9368932 C121.635922,12.9368932 122.468447,13.2313916 123.114078,13.8203883 C123.759709,14.4093851 124.173139,15.1343042 124.354369,15.9951456 L124.354369,15.9951456 Z M136.07767,25.1699029 C136.576052,25.1699029 137.017799,25.1132686 137.402913,25 C137.606796,24.9546926 137.788026,24.8980583 137.946602,24.8300971 L137.946602,24.8300971 L137.946602,21.4320388 C137.855987,21.4773463 137.765372,21.5113269 137.674757,21.5339806 C137.584142,21.5566343 137.482201,21.5736246 137.368932,21.5849515 C137.255663,21.5962783 137.108414,21.6019417 136.927184,21.6019417 C136.247573,21.6019417 135.709547,21.4037217 135.313107,21.0072816 C134.916667,20.6108414 134.718447,20.0728155 134.718447,19.3932039 L134.718447,19.3932039 L134.718447,12.9368932 L138.116505,12.9368932 L138.116505,9.36893204 L134.718447,9.36893204 L134.718447,5.63106796 L131.320388,5.63106796 L131.320388,7.83980583 C131.320388,9.08576052 130.697411,9.70873786 129.451456,9.70873786 L129.451456,9.70873786 L128.432039,9.70873786 L128.432039,12.9368932 L130.81068,12.9368932 L130.81068,19.5631068 C130.81068,20.4239482 130.940939,21.1941748 131.201456,21.8737864 C131.461974,22.5533981 131.824434,23.1423948 132.288835,23.6407767 C132.753236,24.1391586 133.308252,24.5186084 133.953883,24.7791262 C134.599515,25.039644 135.307443,25.1699029 136.07767,25.1699029 Z"
          id="Sprocket"
          fill="#0C1431"
        ></path>
        <path
          d="M9.8045698,17.6699029 C10.7853197,17.6699029 11.718614,17.4681769 12.6044526,17.0647249 C13.4902913,16.6612729 14.2733093,16.1193815 14.9535069,15.4390507 C15.6337044,14.7587199 16.171535,13.9676375 16.5669987,13.0658037 C16.9624623,12.1639698 17.1601942,11.2067602 17.1601942,10.1941748 C17.1601942,9.18158936 16.9624623,8.22437972 16.5669987,7.32254585 C16.171535,6.42071197 15.6337044,5.62962963 14.9535069,4.94929881 C14.2733093,4.268968 13.4902913,3.72707659 12.6044526,3.3236246 C11.718614,2.9201726 10.7853197,2.7184466 9.8045698,2.7184466 L5.09708738,2.7184466 C4.1587395,2.7184466 3.39805825,3.47912785 3.39805825,4.41747573 L3.39805825,15.9708738 C3.39805825,16.9092217 4.1587395,17.6699029 5.09708738,17.6699029 L9.8045698,17.6699029 L9.8045698,17.6699029 Z"
          id="D"
          fill="#EC004F"
          transform="translate(10.279126, 10.194175) rotate(45.000000) translate(-10.279126, -10.194175) "
        ></path>
        <path
          d="M9.8045698,32.2815534 C10.7853197,32.2815534 11.718614,32.0798274 12.6044526,31.6763754 C13.4902913,31.2729234 14.2733093,30.731032 14.9535069,30.0507012 C15.6337044,29.3703704 16.171535,28.579288 16.5669987,27.6774542 C16.9624623,26.7756203 17.1601942,25.8184106 17.1601942,24.8058252 C17.1601942,23.7932398 16.9624623,22.8360302 16.5669987,21.9341963 C16.171535,21.0323625 15.6337044,20.2412801 14.9535069,19.5609493 C14.2733093,18.8806185 13.4902913,18.3387271 12.6044526,17.9352751 C11.718614,17.5318231 10.7853197,17.3300971 9.8045698,17.3300971 L5.09708738,17.3300971 C4.1587395,17.3300971 3.39805825,18.0907783 3.39805825,19.0291262 L3.39805825,30.5825243 C3.39805825,31.5208721 4.1587395,32.2815534 5.09708738,32.2815534 L9.8045698,32.2815534 L9.8045698,32.2815534 Z"
          id="D-Copy"
          fill="#0C1431"
          transform="translate(10.279126, 24.805825) scale(-1, 1) rotate(-45.000000) translate(-10.279126, -24.805825) "
        ></path>
      </g>
    </svg>
  );
}

function SprocketLogotypeDark(props) {
  return (
    <svg
      width="140px"
      height="35px"
      viewBox="0 0 140 35"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Sprocket Branding" fillRule="nonzero">
        <path
          d="M34.4757282,25.1699029 C35.3592233,25.1699029 36.157767,25.039644 36.8713592,24.7791262 C37.5849515,24.5186084 38.1909385,24.1731392 38.6893204,23.7427184 C39.1877023,23.3122977 39.5728155,22.8082524 39.8446602,22.2305825 C40.1165049,21.6529126 40.2524272,21.0469256 40.2524272,20.4126214 C40.2524272,19.4838188 40.0542071,18.7305825 39.657767,18.1529126 C39.2613269,17.5752427 38.7686084,17.105178 38.1796117,16.7427184 C37.5906149,16.3802589 36.9506472,16.1027508 36.2597087,15.9101942 C35.5687702,15.7176375 34.9288026,15.5364078 34.3398058,15.3665049 C33.7508091,15.1966019 33.2580906,15.0097087 32.8616505,14.8058252 C32.4652104,14.6019417 32.2669903,14.3187702 32.2669903,13.9563107 C32.2669903,13.52589 32.4312298,13.1634304 32.7597087,12.868932 C33.0881877,12.5744337 33.5469256,12.4271845 34.1359223,12.4271845 C34.7249191,12.4271845 35.2176375,12.5970874 35.6140777,12.9368932 C36.0105178,13.276699 36.2540453,13.6165049 36.3446602,13.9563107 L36.3446602,13.9563107 L40.0825243,13.9563107 C39.9012945,12.5970874 39.3066343,11.4644013 38.2985437,10.5582524 C37.2904531,9.65210356 35.8462783,9.19902913 33.9660194,9.19902913 C33.105178,9.19902913 32.3349515,9.32928803 31.6553398,9.58980583 C30.9757282,9.85032362 30.3867314,10.1957929 29.8883495,10.6262136 C29.3899676,11.0566343 29.0105178,11.5606796 28.75,12.1383495 C28.4894822,12.7160194 28.3592233,13.3220065 28.3592233,13.9563107 C28.3592233,14.8624595 28.5574434,15.5930421 28.9538835,16.1480583 C29.3503236,16.7030744 29.8430421,17.1561489 30.4320388,17.5072816 C31.0210356,17.8584142 31.6610032,18.1245955 32.3519417,18.3058252 C33.0428803,18.487055 33.6828479,18.6626214 34.2718447,18.8325243 C34.8608414,19.0024272 35.3535599,19.1893204 35.75,19.3932039 C36.1464401,19.5970874 36.3446602,19.8802589 36.3446602,20.2427184 C36.3446602,20.6731392 36.1464401,21.0639159 35.75,21.4150485 C35.3535599,21.7661812 34.815534,21.9417476 34.1359223,21.9417476 C33.4563107,21.9417476 32.9126214,21.7605178 32.5048544,21.3980583 C32.0970874,21.0355987 31.8478964,20.5938511 31.7572816,20.0728155 L31.7572816,20.0728155 L28.0194175,20.0728155 C28.1779935,21.6132686 28.7839806,22.8478964 29.8373786,23.776699 C30.8907767,24.7055016 32.4368932,25.1699029 34.4757282,25.1699029 Z M45.6893204,30.4368932 L45.6893204,23.6407767 C46.0064725,23.9352751 46.368932,24.1957929 46.776699,24.4223301 C47.1391586,24.6035599 47.5639159,24.7734628 48.0509709,24.9320388 C48.5380259,25.0906149 49.1100324,25.1699029 49.7669903,25.1699029 C50.7411003,25.1699029 51.6699029,24.9716828 52.5533981,24.5752427 C53.4368932,24.1788026 54.2127832,23.6237864 54.881068,22.9101942 C55.5493528,22.1966019 56.0817152,21.3527508 56.4781553,20.3786408 C56.8745955,19.4045307 57.0728155,18.3398058 57.0728155,17.184466 C57.0728155,16.0291262 56.8745955,14.9644013 56.4781553,13.9902913 C56.0817152,13.0161812 55.5493528,12.1723301 54.881068,11.4587379 C54.2127832,10.7451456 53.4368932,10.1901294 52.5533981,9.79368932 C51.6699029,9.39724919 50.7411003,9.19902913 49.7669903,9.19902913 C49.0873786,9.19902913 48.4757282,9.28964401 47.9320388,9.47087379 C47.3883495,9.65210356 46.9239482,9.84466019 46.538835,10.0485437 C46.0857605,10.2977346 45.6893204,10.5809061 45.3495146,10.8980583 L45.3495146,10.8980583 L44.6699029,9.36893204 L41.7815534,9.36893204 L41.7815534,30.4368932 L45.6893204,30.4368932 Z M49.2572816,21.4320388 C48.1472492,21.4320388 47.2184466,21.0469256 46.4708738,20.276699 C45.723301,19.5064725 45.3495146,18.4757282 45.3495146,17.184466 C45.3495146,15.8932039 45.723301,14.8624595 46.4708738,14.092233 C47.2184466,13.3220065 48.1472492,12.9368932 49.2572816,12.9368932 C50.3673139,12.9368932 51.2961165,13.3220065 52.0436893,14.092233 C52.7912621,14.8624595 53.1650485,15.8932039 53.1650485,17.184466 C53.1650485,18.4757282 52.7912621,19.5064725 52.0436893,20.276699 C51.2961165,21.0469256 50.3673139,21.4320388 49.2572816,21.4320388 Z M62.5097087,25 L62.5097087,16.6747573 C62.5097087,15.6553398 62.8098706,14.8341424 63.4101942,14.211165 C64.0105178,13.5881877 64.7864078,13.276699 65.7378641,13.276699 C65.9417476,13.276699 66.1286408,13.2880259 66.2985437,13.3106796 C66.4684466,13.3333333 66.6100324,13.3559871 66.723301,13.3786408 C66.8592233,13.4012945 66.9838188,13.4239482 67.0970874,13.4466019 L67.0970874,13.4466019 L67.0970874,9.36893204 L67.0970874,9.36893204 L66.7572816,9.30097087 C66.6440129,9.27831715 66.5194175,9.25566343 66.3834951,9.23300971 C66.2475728,9.21035599 66.0889968,9.19902913 65.907767,9.19902913 C65.3187702,9.19902913 64.7920712,9.29530744 64.3276699,9.48786408 C63.8632686,9.68042071 63.4724919,9.9012945 63.1553398,10.1504854 C62.7702265,10.4223301 62.4417476,10.7281553 62.1699029,11.0679612 L62.1699029,11.0679612 L61.4902913,9.36893204 L58.6019417,9.36893204 L58.6019417,25 L62.5097087,25 Z M75.0825243,25.1699029 C76.1472492,25.1699029 77.1496764,24.960356 78.0898058,24.5412621 C79.0299353,24.1221683 79.8567961,23.5501618 80.5703883,22.8252427 C81.2839806,22.1003236 81.8503236,21.2564725 82.2694175,20.2936893 C82.6885113,19.3309061 82.8980583,18.2944984 82.8980583,17.184466 C82.8980583,16.0744337 82.6885113,15.0380259 82.2694175,14.0752427 C81.8503236,13.1124595 81.2839806,12.2686084 80.5703883,11.5436893 C79.8567961,10.8187702 79.0299353,10.2467638 78.0898058,9.8276699 C77.1496764,9.40857605 76.1472492,9.19902913 75.0825243,9.19902913 C74.0177994,9.19902913 73.0153722,9.40857605 72.0752427,9.8276699 C71.1351133,10.2467638 70.3082524,10.8187702 69.5946602,11.5436893 C68.881068,12.2686084 68.3147249,13.1124595 67.8956311,14.0752427 C67.4765372,15.0380259 67.2669903,16.0744337 67.2669903,17.184466 C67.2669903,18.2944984 67.4765372,19.3309061 67.8956311,20.2936893 C68.3147249,21.2564725 68.881068,22.1003236 69.5946602,22.8252427 C70.3082524,23.5501618 71.1351133,24.1221683 72.0752427,24.5412621 C73.0153722,24.960356 74.0177994,25.1699029 75.0825243,25.1699029 Z M75.0825243,21.4320388 C73.9724919,21.4320388 73.0436893,21.0469256 72.2961165,20.276699 C71.5485437,19.5064725 71.1747573,18.4757282 71.1747573,17.184466 C71.1747573,15.8932039 71.5485437,14.8624595 72.2961165,14.092233 C73.0436893,13.3220065 73.9724919,12.9368932 75.0825243,12.9368932 C76.1925566,12.9368932 77.1213592,13.3220065 77.868932,14.092233 C78.6165049,14.8624595 78.9902913,15.8932039 78.9902913,17.184466 C78.9902913,18.4757282 78.6165049,19.5064725 77.868932,20.276699 C77.1213592,21.0469256 76.1925566,21.4320388 75.0825243,21.4320388 Z M91.3932039,25.1699029 C92.3220065,25.1699029 93.1941748,25.0056634 94.0097087,24.6771845 C94.8252427,24.3487055 95.5501618,23.9069579 96.184466,23.3519417 C96.8187702,22.7969256 97.3511327,22.1626214 97.7815534,21.4490291 C98.2119741,20.7354369 98.5177994,19.9935275 98.6990291,19.223301 L98.6990291,19.223301 L94.7912621,19.223301 C94.6100324,19.6537217 94.3608414,20.0275081 94.0436893,20.3446602 C93.7718447,20.6165049 93.420712,20.8656958 92.9902913,21.092233 C92.5598706,21.3187702 92.0275081,21.4320388 91.3932039,21.4320388 C90.2831715,21.4320388 89.3543689,21.0469256 88.6067961,20.276699 C87.8592233,19.5064725 87.4854369,18.4757282 87.4854369,17.184466 C87.4854369,15.8932039 87.8592233,14.8624595 88.6067961,14.092233 C89.3543689,13.3220065 90.2831715,12.9368932 91.3932039,12.9368932 C92.0275081,12.9368932 92.5598706,13.0558252 92.9902913,13.2936893 C93.420712,13.5315534 93.7718447,13.7864078 94.0436893,14.0582524 C94.3608414,14.3754045 94.6100324,14.7378641 94.7912621,15.1456311 L94.7912621,15.1456311 L98.6990291,15.1456311 C98.5177994,14.3754045 98.2119741,13.6334951 97.7815534,12.9199029 C97.3511327,12.2063107 96.8187702,11.5720065 96.184466,11.0169903 C95.5501618,10.4619741 94.8252427,10.0202265 94.0097087,9.69174757 C93.1941748,9.36326861 92.3220065,9.19902913 91.3932039,9.19902913 C90.328479,9.19902913 89.3260518,9.40857605 88.3859223,9.8276699 C87.4457929,10.2467638 86.618932,10.8187702 85.9053398,11.5436893 C85.1917476,12.2686084 84.6254045,13.1124595 84.2063107,14.0752427 C83.7872168,15.0380259 83.5776699,16.0744337 83.5776699,17.184466 C83.5776699,18.2944984 83.7872168,19.3309061 84.2063107,20.2936893 C84.6254045,21.2564725 85.1917476,22.1003236 85.9053398,22.8252427 C86.618932,23.5501618 87.4457929,24.1221683 88.3859223,24.5412621 C89.3260518,24.960356 90.328479,25.1699029 91.3932039,25.1699029 Z M103.966019,25 L103.966019,17.8640777 L109.402913,25 L113.820388,25 L107.533981,16.8446602 L113.140777,9.36893204 L108.723301,9.36893204 L103.966019,15.8252427 L103.966019,3.59223301 L100.058252,3.59223301 L100.058252,25 L103.966019,25 Z M120.616505,25.1699029 C121.5,25.1699029 122.321197,25.0226537 123.080097,24.7281553 C123.838997,24.433657 124.518608,24.0542071 125.118932,23.5898058 C125.719256,23.1254045 126.228964,22.5987055 126.648058,22.0097087 C127.067152,21.420712 127.378641,20.8317152 127.582524,20.2427184 L127.582524,20.2427184 L123.504854,20.2427184 C123.323625,20.4692557 123.097087,20.6731392 122.825243,20.8543689 C122.576052,21.012945 122.27589,21.1488673 121.924757,21.2621359 C121.573625,21.3754045 121.13754,21.4320388 120.616505,21.4320388 C119.597087,21.4320388 118.79288,21.171521 118.203883,20.6504854 C117.614887,20.1294498 117.229773,19.4838188 117.048544,18.7135922 L117.048544,18.7135922 L127.92233,18.7135922 C127.944984,18.5550162 127.967638,18.3851133 127.990291,18.2038835 C128.012945,18.0453074 128.035599,17.881068 128.058252,17.711165 C128.080906,17.5412621 128.092233,17.3656958 128.092233,17.184466 C128.092233,16.0064725 127.894013,14.9247573 127.497573,13.9393204 C127.101133,12.9538835 126.563107,12.1100324 125.883495,11.407767 C125.203883,10.7055016 124.411003,10.1618123 123.504854,9.77669903 C122.598706,9.39158576 121.635922,9.19902913 120.616505,9.19902913 C119.55178,9.19902913 118.549353,9.40857605 117.609223,9.8276699 C116.669094,10.2467638 115.842233,10.8187702 115.128641,11.5436893 C114.415049,12.2686084 113.848706,13.1124595 113.429612,14.0752427 C113.010518,15.0380259 112.800971,16.0744337 112.800971,17.184466 C112.800971,18.2944984 113.010518,19.3309061 113.429612,20.2936893 C113.848706,21.2564725 114.415049,22.1003236 115.128641,22.8252427 C115.842233,23.5501618 116.669094,24.1221683 117.609223,24.5412621 C118.549353,24.960356 119.55178,25.1699029 120.616505,25.1699029 Z M124.354369,15.9951456 L116.878641,15.9951456 C117.059871,15.1343042 117.473301,14.4093851 118.118932,13.8203883 C118.764563,13.2313916 119.597087,12.9368932 120.616505,12.9368932 C121.635922,12.9368932 122.468447,13.2313916 123.114078,13.8203883 C123.759709,14.4093851 124.173139,15.1343042 124.354369,15.9951456 L124.354369,15.9951456 Z M136.07767,25.1699029 C136.576052,25.1699029 137.017799,25.1132686 137.402913,25 C137.606796,24.9546926 137.788026,24.8980583 137.946602,24.8300971 L137.946602,24.8300971 L137.946602,21.4320388 C137.855987,21.4773463 137.765372,21.5113269 137.674757,21.5339806 C137.584142,21.5566343 137.482201,21.5736246 137.368932,21.5849515 C137.255663,21.5962783 137.108414,21.6019417 136.927184,21.6019417 C136.247573,21.6019417 135.709547,21.4037217 135.313107,21.0072816 C134.916667,20.6108414 134.718447,20.0728155 134.718447,19.3932039 L134.718447,19.3932039 L134.718447,12.9368932 L138.116505,12.9368932 L138.116505,9.36893204 L134.718447,9.36893204 L134.718447,5.63106796 L131.320388,5.63106796 L131.320388,7.83980583 C131.320388,9.08576052 130.697411,9.70873786 129.451456,9.70873786 L129.451456,9.70873786 L128.432039,9.70873786 L128.432039,12.9368932 L130.81068,12.9368932 L130.81068,19.5631068 C130.81068,20.4239482 130.940939,21.1941748 131.201456,21.8737864 C131.461974,22.5533981 131.824434,23.1423948 132.288835,23.6407767 C132.753236,24.1391586 133.308252,24.5186084 133.953883,24.7791262 C134.599515,25.039644 135.307443,25.1699029 136.07767,25.1699029 Z"
          id="Sprocket"
          fill="#FFF"
        ></path>
        <path
          d="M9.8045698,17.6699029 C10.7853197,17.6699029 11.718614,17.4681769 12.6044526,17.0647249 C13.4902913,16.6612729 14.2733093,16.1193815 14.9535069,15.4390507 C15.6337044,14.7587199 16.171535,13.9676375 16.5669987,13.0658037 C16.9624623,12.1639698 17.1601942,11.2067602 17.1601942,10.1941748 C17.1601942,9.18158936 16.9624623,8.22437972 16.5669987,7.32254585 C16.171535,6.42071197 15.6337044,5.62962963 14.9535069,4.94929881 C14.2733093,4.268968 13.4902913,3.72707659 12.6044526,3.3236246 C11.718614,2.9201726 10.7853197,2.7184466 9.8045698,2.7184466 L5.09708738,2.7184466 C4.1587395,2.7184466 3.39805825,3.47912785 3.39805825,4.41747573 L3.39805825,15.9708738 C3.39805825,16.9092217 4.1587395,17.6699029 5.09708738,17.6699029 L9.8045698,17.6699029 L9.8045698,17.6699029 Z"
          id="D"
          fill="#EC004F"
          transform="translate(10.279126, 10.194175) rotate(45.000000) translate(-10.279126, -10.194175) "
        ></path>
        <path
          d="M9.8045698,32.2815534 C10.7853197,32.2815534 11.718614,32.0798274 12.6044526,31.6763754 C13.4902913,31.2729234 14.2733093,30.731032 14.9535069,30.0507012 C15.6337044,29.3703704 16.171535,28.579288 16.5669987,27.6774542 C16.9624623,26.7756203 17.1601942,25.8184106 17.1601942,24.8058252 C17.1601942,23.7932398 16.9624623,22.8360302 16.5669987,21.9341963 C16.171535,21.0323625 15.6337044,20.2412801 14.9535069,19.5609493 C14.2733093,18.8806185 13.4902913,18.3387271 12.6044526,17.9352751 C11.718614,17.5318231 10.7853197,17.3300971 9.8045698,17.3300971 L5.09708738,17.3300971 C4.1587395,17.3300971 3.39805825,18.0907783 3.39805825,19.0291262 L3.39805825,30.5825243 C3.39805825,31.5208721 4.1587395,32.2815534 5.09708738,32.2815534 L9.8045698,32.2815534 L9.8045698,32.2815534 Z"
          id="D-Copy"
          fill="#FFF"
          transform="translate(10.279126, 24.805825) scale(-1, 1) rotate(-45.000000) translate(-10.279126, -24.805825) "
        ></path>
      </g>
    </svg>
  );
}

function AppLogo(props) {
  const fill = props.fill || "#000000";
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="50" height="50" rx="13.3333" fill={fill} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.9489 33.1131V16.6607H17.6865V19.4563H17.881C18.5723 17.5819 20.2359 16.4465 22.4612 16.4465C24.6973 16.4465 26.3069 17.5926 26.9442 19.4563H27.1171C27.8516 17.6247 29.688 16.4465 32.097 16.4465C35.1433 16.4465 37.2822 18.3959 37.2822 22.0699V33.1131H33.3609V22.6697C33.3609 20.6346 32.1078 19.7134 30.5306 19.7134C28.6402 19.7134 27.5276 20.9987 27.5276 22.8518V33.1131H23.6927V22.509C23.6927 20.8167 22.5584 19.7134 20.9056 19.7134C19.2205 19.7134 17.8593 21.0844 17.8593 23.1089V33.1131H13.9489Z"
        fill="#ffffff"
      />
    </svg>
  );
}

function PlayRing(props) {
  const fill = props.fill || "#6236FF";
  return (
    <svg
      width="68"
      height="68"
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34 67.5999C52.5568 67.5999 67.6 52.5567 67.6 33.9999C67.6 15.4431 52.5568 0.399902 34 0.399902C15.4433 0.399902 0.400024 15.4431 0.400024 33.9999C0.400024 52.5567 15.4433 67.5999 34 67.5999Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29.968 25.9358L29.968 42.0638L43.408 33.9998L29.968 25.9358Z"
        fill="white"
      />
    </svg>
  );
}

function AppLogoBig(props) {
  const fill = props.fill || "#6236FF";
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="80" height="80" rx="20" fill="#6236FF" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.3182 52.9811V26.6572H28.2984V31.1302H28.6095C29.7157 28.1311 32.3774 26.3145 35.9379 26.3145C39.5157 26.3145 42.091 28.1482 43.1108 31.1302H43.3873C44.5626 28.1996 47.5009 26.3145 51.3552 26.3145C56.2293 26.3145 59.6515 29.4336 59.6515 35.3119V52.9811H53.3774V36.2716C53.3774 33.0154 51.3725 31.5415 48.849 31.5415C45.8243 31.5415 44.0441 33.5981 44.0441 36.563V52.9811H37.9083V36.0145C37.9083 33.3067 36.0935 31.5415 33.449 31.5415C30.7527 31.5415 28.575 33.7352 28.575 36.9743V52.9811H22.3182Z"
        fill={fill}
      />
    </svg>
  );
}

function SimpleLeftArrow(props) {
  const fill = props.fill || "#6236FF";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 13H16.17L12.29 16.88C11.9 17.27 11.9 17.91 12.29 18.3C12.68 18.69 13.31 18.69 13.7 18.3L19.29 12.71C19.68 12.32 19.68 11.69 19.29 11.3L13.71 5.7C13.32 5.31 12.69 5.31 12.3 5.7C11.91 6.09 11.91 6.72 12.3 7.11L16.17 11H5C4.45 11 4 11.45 4 12C4 12.55 4.45 13 5 13Z"
        fill={fill}
      />
    </svg>
  );
}

function SimpleLeftArrowCustom(props) {
  const fill = props.fill || "#6236FF";
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4254 5.59189C11.1004 5.26689 10.5754 5.26689 10.2504 5.59189L6.42539 9.41689C6.10039 9.74189 6.10039 10.2669 6.42539 10.5919L10.2504 14.4169C10.5754 14.7419 11.1004 14.7419 11.4254 14.4169C11.7504 14.0919 11.7504 13.5669 11.4254 13.2419L8.19206 10.0002L11.4254 6.76689C11.7504 6.44189 11.7421 5.90856 11.4254 5.59189Z"
        fill={fill}
      />
    </svg>
  );
}

function UserIcon(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 8C8 10.2091 9.79086 12 12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8ZM20 18C20 15.34 14.67 14 12 14C9.33 14 4 15.34 4 18V19C4 19.55 4.45 20 5 20H19C19.55 20 20 19.55 20 19V18Z"
        fill={fill}
      />
    </svg>
  );
}

function EmailIcon(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM19.6 8.25L12.53 12.67C12.21 12.87 11.79 12.87 11.47 12.67L4.4 8.25C4.15 8.09 4 7.82 4 7.53C4 6.86 4.73 6.46 5.3 6.81L12 11L18.7 6.81C19.27 6.46 20 6.86 20 7.53C20 7.82 19.85 8.09 19.6 8.25Z"
        fill={fill}
      />
    </svg>
  );
}

function Network(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM18.92 8H15.97C15.65 6.75 15.19 5.55 14.59 4.44C16.43 5.07 17.96 6.35 18.92 8ZM12 4.04C12.83 5.24 13.48 6.57 13.91 8H10.09C10.52 6.57 11.17 5.24 12 4.04ZM4.26 14C4.1 13.36 4 12.69 4 12C4 11.31 4.1 10.64 4.26 10H7.64C7.56 10.66 7.5 11.32 7.5 12C7.5 12.68 7.56 13.34 7.64 14H4.26ZM5.08 16H8.03C8.35 17.25 8.81 18.45 9.41 19.56C7.57 18.93 6.04 17.66 5.08 16ZM8.03 8H5.08C6.04 6.34 7.57 5.07 9.41 4.44C8.81 5.55 8.35 6.75 8.03 8ZM12 19.96C11.17 18.76 10.52 17.43 10.09 16H13.91C13.48 17.43 12.83 18.76 12 19.96ZM14.34 14H9.66C9.57 13.34 9.5 12.68 9.5 12C9.5 11.32 9.57 10.65 9.66 10H14.34C14.43 10.65 14.5 11.32 14.5 12C14.5 12.68 14.43 13.34 14.34 14ZM14.59 19.56C15.19 18.45 15.65 17.25 15.97 16H18.92C17.96 17.65 16.43 18.93 14.59 19.56ZM16.36 14C16.44 13.34 16.5 12.68 16.5 12C16.5 11.32 16.44 10.66 16.36 10H19.74C19.9 10.64 20 11.31 20 12C20 12.69 19.9 13.36 19.74 14H16.36Z"
        fill={fill}
      />
    </svg>
  );
}

function DeleteOutline(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V9C18 7.9 17.1 7 16 7H8C6.9 7 6 7.9 6 9V19ZM9 9H15C15.55 9 16 9.45 16 10V18C16 18.55 15.55 19 15 19H9C8.45 19 8 18.55 8 18V10C8 9.45 8.45 9 9 9ZM15.5 4L14.79 3.29C14.61 3.11 14.35 3 14.09 3H9.91C9.65 3 9.39 3.11 9.21 3.29L8.5 4H6C5.45 4 5 4.45 5 5C5 5.55 5.45 6 6 6H18C18.55 6 19 5.55 19 5C19 4.45 18.55 4 18 4H15.5Z"
        fill={fill}
      />
    </svg>
  );
}

function ChevronLeft(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.71 6.71C13.32 6.32 12.69 6.32 12.3 6.71L7.71001 11.3C7.32001 11.69 7.32001 12.32 7.71001 12.71L12.3 17.3C12.69 17.69 13.32 17.69 13.71 17.3C14.1 16.91 14.1 16.28 13.71 15.89L9.83001 12L13.71 8.12C14.1 7.73 14.09 7.09 13.71 6.71Z"
        fill={fill}
      />
    </svg>
  );
}

function Card(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM19 18H5C4.45 18 4 17.55 4 17V12H20V17C20 17.55 19.55 18 19 18ZM20 8H4V6H20V8Z"
        fill={fill}
      />
    </svg>
  );
}

function Donut(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 3.17995V20.82C11 21.46 10.41 21.94 9.79 21.8C5.32 20.8 2 16.79 2 12C2 7.20995 5.32 3.19995 9.79 2.19995C10.41 2.05995 11 2.53995 11 3.17995ZM13.03 3.17995V9.98995C13.03 10.54 13.48 10.99 14.03 10.99H20.82C21.46 10.99 21.94 10.4 21.8 9.76995C20.95 6.00995 18 3.04995 14.25 2.19995C13.62 2.05995 13.03 2.53995 13.03 3.17995ZM13.03 14.01V20.82C13.03 21.46 13.62 21.94 14.25 21.8C18.01 20.95 20.96 17.98 21.81 14.22C21.95 13.6 21.46 13 20.83 13H14.04C13.48 13.01 13.03 13.46 13.03 14.01Z"
        fill={fill}
      />
    </svg>
  );
}

function Support(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 6H19V14C19 14.55 18.55 15 18 15H6V16C6 17.1 6.9 18 8 18H18L22 22V8C22 6.9 21.1 6 20 6ZM17 11V4C17 2.9 16.1 2 15 2H4C2.9 2 2 2.9 2 4V17L6 13H15C16.1 13 17 12.1 17 11Z"
        fill={fill}
      />
    </svg>
  );
}

function Face(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 11.75C8.31 11.75 7.75 12.31 7.75 13C7.75 13.69 8.31 14.25 9 14.25C9.69 14.25 10.25 13.69 10.25 13C10.25 12.31 9.69 11.75 9 11.75ZM15 11.75C14.31 11.75 13.75 12.31 13.75 13C13.75 13.69 14.31 14.25 15 14.25C15.69 14.25 16.25 13.69 16.25 13C16.25 12.31 15.69 11.75 15 11.75ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 11.71 4.02 11.42 4.05 11.14C6.41 10.09 8.28 8.16 9.26 5.77C11.07 8.33 14.05 10 17.42 10C18.2 10 18.95 9.91 19.67 9.74C19.88 10.45 20 11.21 20 12C20 16.41 16.41 20 12 20Z"
        fill={fill}
      />
    </svg>
  );
}

function Document(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.59 2.59C14.21 2.21 13.7 2 13.17 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.89 22 5.99 22H18C19.1 22 20 21.1 20 20V8.83C20 8.3 19.79 7.79 19.41 7.42L14.59 2.59ZM15 18H9C8.45 18 8 17.55 8 17C8 16.45 8.45 16 9 16H15C15.55 16 16 16.45 16 17C16 17.55 15.55 18 15 18ZM15 14H9C8.45 14 8 13.55 8 13C8 12.45 8.45 12 9 12H15C15.55 12 16 12.45 16 13C16 13.55 15.55 14 15 14ZM13 8V3.5L18.5 9H14C13.45 9 13 8.55 13 8Z"
        fill={fill}
      />
    </svg>
  );
}

function Reply(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 9V7.41C10 6.52 8.92 6.07 8.29 6.7L3.7 11.29C3.31 11.68 3.31 12.31 3.7 12.7L8.29 17.29C8.92 17.92 10 17.48 10 16.59V14.9C15 14.9 18.5 16.5 21 20C20 15 17 10 10 9Z"
        fill={fill}
      />
    </svg>
  );
}

function Rotate(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.65 8.35L15.86 11.14C15.54 11.46 15.76 12 16.21 12H18C18 15.31 15.31 18 12 18C11.21 18 10.44 17.85 9.75 17.56C9.39 17.41 8.98 17.52 8.71 17.79C8.2 18.3 8.38 19.16 9.05 19.43C9.96 19.8 10.96 20 12 20C16.42 20 20 16.42 20 12H21.79C22.24 12 22.46 11.46 22.14 11.15L19.35 8.36C19.16 8.16 18.84 8.16 18.65 8.35ZM6 12C6 8.69 8.69 6 12 6C12.79 6 13.56 6.15 14.25 6.44C14.61 6.59 15.02 6.48 15.29 6.21C15.8 5.7 15.62 4.84 14.95 4.57C14.04 4.2 13.04 4 12 4C7.58 4 4 7.58 4 12H2.21C1.76 12 1.54 12.54 1.86 12.85L4.65 15.64C4.85 15.84 5.16 15.84 5.36 15.64L8.15 12.85C8.46 12.54 8.24 12 7.79 12H6Z"
        fill={fill}
      />
    </svg>
  );
}

function Location(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C8.13 2 5 5.13 5 9C5 13.17 9.42 18.92 11.24 21.11C11.64 21.59 12.37 21.59 12.77 21.11C14.58 18.92 19 13.17 19 9C19 5.13 15.87 2 12 2ZM12 11.5C10.62 11.5 9.5 10.38 9.5 9C9.5 7.62 10.62 6.5 12 6.5C13.38 6.5 14.5 7.62 14.5 9C14.5 10.38 13.38 11.5 12 11.5Z"
        fill={fill}
      />
    </svg>
  );
}

function Flight(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5 19H3.49999C2.94999 19 2.49999 19.45 2.49999 20C2.49999 20.55 2.94999 21 3.49999 21H20.5C21.05 21 21.5 20.55 21.5 20C21.5 19.45 21.05 19 20.5 19ZM22.07 9.64C21.85 8.84 21.03 8.37 20.23 8.58L14.92 10L8.45999 3.98C8.18999 3.72 7.79999 3.63 7.43999 3.73C6.75999 3.92 6.43999 4.7 6.78999 5.31L10.23 11.27L5.25999 12.6L3.68999 11.36C3.43999 11.17 3.11999 11.1 2.80999 11.18L2.47999 11.27C2.15999 11.35 2.00999 11.72 2.17999 12L4.05999 15.25C4.28999 15.64 4.74999 15.83 5.17999 15.72L21 11.48C21.8 11.26 22.28 10.44 22.07 9.64Z"
        fill={fill}
      />
    </svg>
  );
}

function Bookmark(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 3H7C5.9 3 5 3.9 5 5V21L12 18L19 21V5C19 3.9 18.1 3 17 3Z"
        fill={fill}
      />
    </svg>
  );
}

function Bookmarks(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 18L21 19V3C21 1.9 20.1 1 19 1H8.99C7.89 1 7 1.9 7 3H17C18.1 3 19 3.9 19 5V18ZM15 5H5C3.9 5 3 5.9 3 7V23L10 20L17 23V7C17 5.9 16.1 5 15 5Z"
        fill={fill}
      />
    </svg>
  );
}

function DeleteForever(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V9C18 7.9 17.1 7 16 7H8C6.9 7 6 7.9 6 9V19ZM9.17 11.17C9.56 10.78 10.19 10.78 10.58 11.17L12 12.59L13.42 11.17C13.81 10.78 14.44 10.78 14.83 11.17C15.22 11.56 15.22 12.19 14.83 12.58L13.41 14L14.83 15.42C15.22 15.81 15.22 16.44 14.83 16.83C14.44 17.22 13.81 17.22 13.42 16.83L12 15.41L10.58 16.83C10.19 17.22 9.56 17.22 9.17 16.83C8.78 16.44 8.78 15.81 9.17 15.42L10.59 14L9.17 12.58C8.78 12.2 8.78 11.56 9.17 11.17ZM15.5 4L14.79 3.29C14.61 3.11 14.35 3 14.09 3H9.91C9.65 3 9.39 3.11 9.21 3.29L8.5 4H6C5.45 4 5 4.45 5 5C5 5.55 5.45 6 6 6H18C18.55 6 19 5.55 19 5C19 4.45 18.55 4 18 4H15.5Z"
        fill={fill}
      />
    </svg>
  );
}

function Flash(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2.02C6.48999 2.02 2.01999 6.49 2.01999 12C2.01999 17.51 6.48999 21.98 12 21.98C17.51 21.98 21.98 17.51 21.98 12C21.98 6.49 17.51 2.02 12 2.02ZM11.48 17.88V13.74H8.81999C8.44999 13.74 8.19999 13.34 8.37999 13.01L12.06 5.84C12.29 5.37 13 5.54 13 6.07V10.26H15.54C15.91 10.26 16.15 10.65 15.99 10.98L12.43 18.1C12.19 18.58 11.48 18.41 11.48 17.88Z"
        fill={fill}
      />
    </svg>
  );
}

function VisibilityOn(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4C7 4 2.73 7.11 1 11.5C2.73 15.89 7 19 12 19C17 19 21.27 15.89 23 11.5C21.27 7.11 17 4 12 4ZM12 16.5C9.24 16.5 7 14.26 7 11.5C7 8.74 9.24 6.5 12 6.5C14.76 6.5 17 8.74 17 11.5C17 14.26 14.76 16.5 12 16.5ZM12 8.5C10.34 8.5 9 9.84 9 11.5C9 13.16 10.34 14.5 12 14.5C13.66 14.5 15 13.16 15 11.5C15 9.84 13.66 8.5 12 8.5Z"
        fill={fill}
      />
    </svg>
  );
}

function Fire(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.09 4.56C16.39 3.53 15.59 2.57 14.69 1.71C14.34 1.37 13.75 1.69 13.85 2.17C14.04 3.11 14.24 4.35 14.24 5.46C14.24 7.52 12.89 9.19 10.83 9.19C9.29 9.19 8.03 8.26 7.48 6.93C7.38 6.73 7.34 6.61 7.28 6.39C7.17 5.97 6.62 5.84 6.38 6.21C6.2 6.48 6.03 6.75 5.87 7.04C4.68 9.08 4 11.46 4 14C4 18.42 7.58 22 12 22C16.42 22 20 18.42 20 14C20 10.51 18.92 7.27 17.09 4.56ZM11.71 19C9.93 19 8.49 17.6 8.49 15.86C8.49 14.24 9.54 13.1 11.3 12.74C12.77 12.44 14.28 11.81 15.33 10.82C15.61 10.56 16.07 10.68 16.15 11.05C16.38 12.07 16.5 13.13 16.5 14.2C16.51 16.85 14.36 19 11.71 19Z"
        fill={fill}
      />
    </svg>
  );
}

function Email(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM19.6 8.25L12.53 12.67C12.21 12.87 11.79 12.87 11.47 12.67L4.4 8.25C4.15 8.09 4 7.82 4 7.53C4 6.86 4.73 6.46 5.3 6.81L12 11L18.7 6.81C19.27 6.46 20 6.86 20 7.53C20 7.82 19.85 8.09 19.6 8.25Z"
        fill={fill}
      />
    </svg>
  );
}

function Assignment(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 3H14.82C14.4 1.84 13.3 1 12 1C10.7 1 9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM12 3C12.55 3 13 3.45 13 4C13 4.55 12.55 5 12 5C11.45 5 11 4.55 11 4C11 3.45 11.45 3 12 3ZM12 7C13.66 7 15 8.34 15 10C15 11.66 13.66 13 12 13C10.34 13 9 11.66 9 10C9 8.34 10.34 7 12 7ZM18 19H6V17.6C6 15.6 10 14.5 12 14.5C14 14.5 18 15.6 18 17.6V19Z"
        fill={fill}
      />
    </svg>
  );
}

function Home(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.99998 19.0002V14.0002H14V19.0002C14 19.5502 14.45 20.0002 15 20.0002H18C18.55 20.0002 19 19.5502 19 19.0002V12.0002H20.7C21.16 12.0002 21.38 11.4302 21.03 11.1302L12.67 3.60021C12.29 3.26021 11.71 3.26021 11.33 3.60021L2.96998 11.1302C2.62998 11.4302 2.83998 12.0002 3.29998 12.0002H4.99998V19.0002C4.99998 19.5502 5.44998 20.0002 5.99998 20.0002H8.99998C9.54998 20.0002 9.99998 19.5502 9.99998 19.0002Z"
        fill={fill}
      />
    </svg>
  );
}

function ChevronDown(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.12 9.29L12 13.17L15.88 9.29C16.27 8.9 16.9 8.9 17.29 9.29C17.68 9.68 17.68 10.31 17.29 10.7L12.7 15.29C12.31 15.68 11.68 15.68 11.29 15.29L6.7 10.7C6.31 10.31 6.31 9.68 6.7 9.29C7.09 8.91 7.73 8.9 8.12 9.29Z"
        fill={fill}
      />
    </svg>
  );
}

function ChevronRight(props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.71 17.3C10.1 17.69 10.73 17.69 11.12 17.3L15.71 12.71C16.1 12.32 16.1 11.69 15.71 11.3L11.12 6.71C10.73 6.32 10.1 6.32 9.71 6.71C9.32 7.1 9.32 7.73 9.71 8.12L13.59 12.01L9.71 15.89C9.32 16.28 9.33 16.92 9.71 17.3Z"
        fill="#18214D"
      />
    </svg>
  );
}

function ArrowRight(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 13H16.17L12.29 16.88C11.9 17.27 11.9 17.91 12.29 18.3C12.68 18.69 13.31 18.69 13.7 18.3L19.29 12.71C19.68 12.32 19.68 11.69 19.29 11.3L13.71 5.7C13.32 5.31 12.69 5.31 12.3 5.7C11.91 6.09 11.91 6.72 12.3 7.11L16.17 11H5C4.45 11 4 11.45 4 12C4 12.55 4.45 13 5 13Z"
        fill={fill}
      />
    </svg>
  );
}

function ArrowLeft(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5825 11L7.41249 11L11.2925 7.12C11.6825 6.73 11.6825 6.09 11.2925 5.7C10.9025 5.31 10.2725 5.31 9.88249 5.7L4.29249 11.29C3.90249 11.68 3.90249 12.31 4.29249 12.7L9.87249 18.3C10.2625 18.69 10.8925 18.69 11.2825 18.3C11.6725 17.91 11.6725 17.28 11.2825 16.89L7.41249 13L18.5825 13C19.1325 13 19.5825 12.55 19.5825 12C19.5825 11.45 19.1325 11 18.5825 11Z"
        fill={fill}
      />
    </svg>
  );
}

function Basket(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 8.9998H17.21L12.82 2.4298C12.42 1.8398 11.55 1.8398 11.16 2.4298L6.77 8.9998H2C1.45 8.9998 1 9.4498 1 9.9998C1 10.0898 1.01 10.1798 1.04 10.2698L3.58 19.5398C3.81 20.3798 4.58 20.9998 5.5 20.9998H18.5C19.42 20.9998 20.19 20.3798 20.43 19.5398L22.97 10.2698L23 9.9998C23 9.4498 22.55 8.9998 22 8.9998ZM11.99 4.7898L14.8 8.9998H9.18L11.99 4.7898ZM12 16.9998C10.9 16.9998 10 16.0998 10 14.9998C10 13.8998 10.9 12.9998 12 12.9998C13.1 12.9998 14 13.8998 14 14.9998C14 16.0998 13.1 16.9998 12 16.9998Z"
        fill={fill}
      />
    </svg>
  );
}

function Extension(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5 11H19V7C19 5.9 18.1 5 17 5H13V3.5C13 2.12 11.88 1 10.5 1C9.12 1 8 2.12 8 3.5V5H4C2.9 5 2.01 5.9 2.01 7V10.8H3.5C4.99 10.8 6.2 12.01 6.2 13.5C6.2 14.99 4.99 16.2 3.5 16.2H2V20C2 21.1 2.9 22 4 22H7.8V20.5C7.8 19.01 9.01 17.8 10.5 17.8C11.99 17.8 13.2 19.01 13.2 20.5V22H17C18.1 22 19 21.1 19 20V16H20.5C21.88 16 23 14.88 23 13.5C23 12.12 21.88 11 20.5 11Z"
        fill={fill}
      />
    </svg>
  );
}

function Date(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 4H18V3C18 2.45 17.55 2 17 2C16.45 2 16 2.45 16 3V4H8V3C8 2.45 7.55 2 7 2C6.45 2 6 2.45 6 3V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 19C19 19.55 18.55 20 18 20H6C5.45 20 5 19.55 5 19V9H19V19ZM7 11H9V13H7V11ZM11 11H13V13H11V11ZM15 11H17V13H15V11Z"
        fill={fill}
      />
    </svg>
  );
}

function ChevronUp(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.00064 14.9994C7.39064 15.3894 8.02064 15.3894 8.41064 14.9994L12.2906 11.1194L16.1706 14.9994C16.5606 15.3894 17.1906 15.3894 17.5806 14.9994C17.9706 14.6094 17.9706 13.9794 17.5806 13.5894L12.9906 8.99937C12.6006 8.60937 11.9706 8.60937 11.5806 8.99937L6.99064 13.5894C6.61064 13.9694 6.61064 14.6094 7.00064 14.9994Z"
        fill={fill}
      />
    </svg>
  );
}

function Chat(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 2H4C2.9 2 2.01 2.9 2.01 4L2 22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM7 9H17C17.55 9 18 9.45 18 10C18 10.55 17.55 11 17 11H7C6.45 11 6 10.55 6 10C6 9.45 6.45 9 7 9ZM13 14H7C6.45 14 6 13.55 6 13C6 12.45 6.45 12 7 12H13C13.55 12 14 12.45 14 13C14 13.55 13.55 14 13 14ZM17 8H7C6.45 8 6 7.55 6 7C6 6.45 6.45 6 7 6H17C17.55 6 18 6.45 18 7C18 7.55 17.55 8 17 8Z"
        fill={fill}
      />
    </svg>
  );
}

function Block(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM12 17C10.9 17 10 16.1 10 15C10 13.9 10.9 13 12 13C13.1 13 14 13.9 14 15C14 16.1 13.1 17 12 17ZM9 8V6C9 4.34 10.34 3 12 3C13.66 3 15 4.34 15 6V8H9Z"
        fill={fill}
      />
    </svg>
  );
}

function Group(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5 12C17.88 12 18.99 10.88 18.99 9.5C18.99 8.12 17.88 7 16.5 7C15.12 7 14 8.12 14 9.5C14 10.88 15.12 12 16.5 12ZM9 11C10.66 11 11.99 9.66 11.99 8C11.99 6.34 10.66 5 9 5C7.34 5 6 6.34 6 8C6 9.66 7.34 11 9 11ZM16.5 14C14.67 14 11 14.92 11 16.75V18C11 18.55 11.45 19 12 19H21C21.55 19 22 18.55 22 18V16.75C22 14.92 18.33 14 16.5 14ZM9 13C6.67 13 2 14.17 2 16.5V18C2 18.55 2.45 19 3 19H9V16.75C9 15.9 9.33 14.41 11.37 13.28C10.5 13.1 9.66 13 9 13Z"
        fill={fill}
      />
    </svg>
  );
}

function Camera(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 15C10.3431 15 9 13.6569 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15ZM20 4C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4H7.17L8.4 2.65C8.78 2.24 9.32 2 9.88 2H14.12C14.68 2 15.22 2.24 15.59 2.65L16.83 4H20ZM12 17C14.76 17 17 14.76 17 12C17 9.24 14.76 7 12 7C9.24 7 7 9.24 7 12C7 14.76 9.24 17 12 17Z"
        fill={fill}
      />
    </svg>
  );
}

function Delete(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V9C18 7.9 17.1 7 16 7H8C6.9 7 6 7.9 6 9V19ZM18 4H15.5L14.79 3.29C14.61 3.11 14.35 3 14.09 3H9.91C9.65 3 9.39 3.11 9.21 3.29L8.5 4H6C5.45 4 5 4.45 5 5C5 5.55 5.45 6 6 6H18C18.55 6 19 5.55 19 5C19 4.45 18.55 4 18 4Z"
        fill={fill}
      />
    </svg>
  );
}

function AppStore(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.4272 1.33334C20.5976 2.78828 19.9838 4.22202 19.0866 5.27586C18.1503 6.31332 16.6526 7.10684 15.1939 7.00464C15.0029 5.60465 15.7421 4.11595 16.5694 3.2077C17.5047 2.17699 19.1287 1.38733 20.4272 1.33334ZM25.9607 11.4892C25.7972 11.5809 23.1002 13.0933 23.1297 16.1771C23.1636 19.9017 26.5985 21.133 26.6405 21.1465C26.62 21.2333 26.1026 22.9235 24.8143 24.6397C23.7384 26.1506 22.6113 27.6277 20.821 27.6547C19.9699 27.6731 19.3951 27.4432 18.7963 27.2037C18.1716 26.9538 17.5206 26.6935 16.5023 26.6935C15.4226 26.6935 14.7428 26.9622 14.0871 27.2214C13.5202 27.4454 12.9714 27.6624 12.1979 27.6923C10.4928 27.7512 9.19012 26.0793 8.07528 24.5819C5.84663 21.5245 4.11175 15.966 6.43793 12.1835C7.56508 10.3284 9.62025 9.13381 11.8171 9.10198C12.7845 9.08341 13.7123 9.43357 14.5256 9.74054C15.1476 9.97528 15.7027 10.1848 16.1573 10.1848C16.5566 10.1848 17.0961 9.98366 17.7249 9.74926C18.7158 9.37987 19.9285 8.92782 21.1639 9.04992C22.0088 9.07306 24.4129 9.36328 25.9641 11.4873L25.9607 11.4892Z"
        fill={fill}
      />
    </svg>
  );
}

function PlayMarket(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.9518 2.82508L18.5506 16.0195L6.01229 29.3291C5.64639 29.0858 5.45024 28.5575 5.44692 27.8752C5.44063 26.5675 5.3408 5.80978 5.33329 4.25234C5.32979 3.50534 5.58887 3.04951 5.9518 2.82508ZM22.7055 11.6096L7.38517 2.84305C7.22153 2.74918 7.0357 2.69215 6.85057 2.66666L19.072 15.4663L22.7055 11.6096ZM23.3862 19.9848L19.5964 16.0159L23.3824 11.9972L28.5962 14.98C29.8806 15.7146 29.2237 16.6336 28.5962 16.9939L23.3862 19.9848ZM7.05085 29.3333C7.15767 29.2912 7.26921 29.2374 7.38493 29.1711L22.7084 20.3739L19.0755 16.5692L7.05085 29.3333Z"
        fill={fill}
      />
    </svg>
  );
}

function Download(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8251 7.5H12.5001V3.33333C12.5001 2.875 12.1251 2.5 11.6667 2.5H8.33341C7.87508 2.5 7.50008 2.875 7.50008 3.33333V7.5H6.17508C5.43341 7.5 5.05841 8.4 5.58341 8.925L9.40841 12.75C9.73341 13.075 10.2584 13.075 10.5834 12.75L14.4084 8.925C14.9334 8.4 14.5667 7.5 13.8251 7.5ZM4.16675 15.8333C4.16675 16.2917 4.54175 16.6667 5.00008 16.6667H15.0001C15.4584 16.6667 15.8334 16.2917 15.8334 15.8333C15.8334 15.375 15.4584 15 15.0001 15H5.00008C4.54175 15 4.16675 15.375 4.16675 15.8333Z"
        fill={fill}
      />
    </svg>
  );
}

function Alternate(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.72 2.03001C6.63001 1.60001 1.60001 6.63001 2.03001 12.72C2.39001 18.01 7.01001 22 12.31 22H16C16.55 22 17 21.55 17 21C17 20.45 16.55 20 16 20H12.33C8.60001 20 5.18001 17.58 4.25001 13.97C2.76001 8.17001 8.16001 2.76001 13.96 4.26001C17.58 5.18001 20 8.60001 20 12.33V13.43C20 14.22 19.29 15 18.5 15C17.71 15 17 14.22 17 13.43V12.18C17 9.67001 15.22 7.41001 12.74 7.06001C9.34001 6.57001 6.47001 9.51001 7.08001 12.93C7.42001 14.84 8.91001 16.42 10.8 16.87C12.64 17.3 14.39 16.71 15.54 15.54C16.43 16.76 18.21 17.4 19.84 16.75C21.18 16.22 22 14.85 22 13.41V12.32C22 7.01001 18.01 2.39001 12.72 2.03001ZM12 15C10.34 15 9.00001 13.66 9.00001 12C9.00001 10.34 10.34 9.00001 12 9.00001C13.66 9.00001 15 10.34 15 12C15 13.66 13.66 15 12 15Z"
        fill={fill}
      />
    </svg>
  );
}

function Upload(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.35 10.04C18.67 6.59 15.64 4 12 4C9.11 4 6.6 5.64 5.35 8.04C2.34 8.36 0 10.91 0 14C0 17.31 2.69 20 6 20H19C21.76 20 24 17.76 24 15C24 12.36 21.95 10.22 19.35 10.04ZM14 13V17H10V13H7L11.65 8.35C11.85 8.15 12.16 8.15 12.36 8.35L17 13H14Z"
        fill={fill}
      />
    </svg>
  );
}

function Carousel(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 19H16C16.55 19 17 18.55 17 18V5C17 4.45 16.55 4 16 4H8C7.45 4 7 4.45 7 5V18C7 18.55 7.45 19 8 19ZM3 17H5C5.55 17 6 16.55 6 16V7C6 6.45 5.55 6 5 6H3C2.45 6 2 6.45 2 7V16C2 16.55 2.45 17 3 17ZM18 7V16C18 16.55 18.45 17 19 17H21C21.55 17 22 16.55 22 16V7C22 6.45 21.55 6 21 6H19C18.45 6 18 6.45 18 7Z"
        fill={fill}
      />
    </svg>
  );
}

function Dashboard(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 9.6875H7.625C8.00313 9.6875 8.3125 9.37813 8.3125 9V3.5C8.3125 3.12187 8.00313 2.8125 7.625 2.8125H3.5C3.12187 2.8125 2.8125 3.12187 2.8125 3.5V9C2.8125 9.37813 3.12187 9.6875 3.5 9.6875ZM3.5 15.1875H7.625C8.00313 15.1875 8.3125 14.8781 8.3125 14.5V11.75C8.3125 11.3719 8.00313 11.0625 7.625 11.0625H3.5C3.12187 11.0625 2.8125 11.3719 2.8125 11.75V14.5C2.8125 14.8781 3.12187 15.1875 3.5 15.1875ZM10.375 15.1875H14.5C14.8781 15.1875 15.1875 14.8781 15.1875 14.5V9C15.1875 8.62187 14.8781 8.3125 14.5 8.3125H10.375C9.99687 8.3125 9.6875 8.62187 9.6875 9V14.5C9.6875 14.8781 9.99687 15.1875 10.375 15.1875ZM9.6875 3.5V6.25C9.6875 6.62813 9.99687 6.9375 10.375 6.9375H14.5C14.8781 6.9375 15.1875 6.62813 15.1875 6.25V3.5C15.1875 3.12187 14.8781 2.8125 14.5 2.8125H10.375C9.99687 2.8125 9.6875 3.12187 9.6875 3.5Z"
        fill={fill}
      />
    </svg>
  );
}

function Clock(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM15.55 15.8L11.47 13.29C11.17 13.11 10.99 12.79 10.99 12.44V7.75C11 7.34 11.34 7 11.75 7C12.16 7 12.5 7.34 12.5 7.75V12.2L16.34 14.51C16.7 14.73 16.82 15.2 16.6 15.56C16.38 15.91 15.91 16.02 15.55 15.8Z"
        fill={fill}
      />
    </svg>
  );
}

function Explore(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 10.9C11.39 10.9 10.9 11.39 10.9 12C10.9 12.61 11.39 13.1 12 13.1C12.61 13.1 13.1 12.61 13.1 12C13.1 11.39 12.61 10.9 12 10.9ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM14.19 14.19L6 18L9.81 9.81L18 6L14.19 14.19Z"
        fill={fill}
      />
    </svg>
  );
}

function Update(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 8.75V12.43C11 12.78 11.19 13.11 11.49 13.29L14.61 15.14C14.97 15.35 15.43 15.23 15.64 14.88C15.85 14.52 15.74 14.06 15.38 13.85L12.51 12.14V8.74C12.5 8.34 12.16 8 11.75 8C11.34 8 11 8.34 11 8.75ZM21 9.5V4.21C21 3.76 20.46 3.54 20.15 3.86L18.37 5.64C16.56 3.83 13.98 2.79 11.16 3.04C6.97 3.42 3.52 6.79 3.06 10.98C2.46 16.4 6.69 21 12 21C16.59 21 20.38 17.56 20.93 13.12C21 12.52 20.53 12 19.93 12C19.43 12 19.01 12.37 18.95 12.86C18.52 16.35 15.51 19.05 11.9 19C8.19 18.95 5.06 15.82 5 12.1C4.94 8.2 8.11 5 12 5C13.93 5 15.68 5.79 16.95 7.05L14.86 9.14C14.54 9.46 14.76 10 15.21 10H20.5C20.78 10 21 9.78 21 9.5Z"
        fill={fill}
      />
    </svg>
  );
}

function FavoriteBorder(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.66 3.99C17.02 2.19 13.76 3.03 12 5.09C10.24 3.03 6.98 2.18 4.34 3.99C2.94 4.95 2.06 6.57 2 8.28C1.86 12.16 5.3 15.27 10.55 20.04L10.65 20.13C11.41 20.82 12.58 20.82 13.34 20.12L13.45 20.02C18.7 15.26 22.13 12.15 22 8.27C21.94 6.57 21.06 4.95 19.66 3.99ZM12.1 18.55L12 18.65L11.9 18.55C7.14 14.24 4 11.39 4 8.5C4 6.5 5.5 5 7.5 5C9.04 5 10.54 5.99 11.07 7.36H12.94C13.46 5.99 14.96 5 16.5 5C18.5 5 20 6.5 20 8.5C20 11.39 16.86 14.24 12.1 18.55Z"
        fill={fill}
      />
    </svg>
  );
}

function Earth(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 19.93C7.05 19.44 4 16.08 4 12C4 11.38 4.08 10.79 4.21 10.21L9 15V16C9 17.1 9.9 18 11 18V19.93ZM17.9 17.39C17.64 16.58 16.9 16 16 16H15V13C15 12.45 14.55 12 14 12H8V10H10C10.55 10 11 9.55 11 9V7H13C14.1 7 15 6.1 15 5V4.59C17.93 5.78 20 8.65 20 12C20 14.08 19.2 15.97 17.9 17.39Z"
        fill={fill}
      />
    </svg>
  );
}

function Send(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.4 20.4L20.85 12.92C21.66 12.57 21.66 11.43 20.85 11.08L3.4 3.6C2.74 3.31 2.01 3.8 2.01 4.51L2 9.12C2 9.62 2.37 10.05 2.87 10.11L17 12L2.87 13.88C2.37 13.95 2 14.38 2 14.88L2.01 19.49C2.01 20.2 2.74 20.69 3.4 20.4Z"
        fill={fill}
      />
    </svg>
  );
}

function TimeLine(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23 8C23 9.1 22.1 10 21 10C20.82 10 20.65 9.98 20.49 9.93L16.93 13.48C16.98 13.64 17 13.82 17 14C17 15.1 16.1 16 15 16C13.9 16 13 15.1 13 14C13 13.82 13.02 13.64 13.07 13.48L10.52 10.93C10.36 10.98 10.18 11 10 11C9.82 11 9.64 10.98 9.48 10.93L4.93 15.49C4.98 15.65 5 15.82 5 16C5 17.1 4.1 18 3 18C1.9 18 1 17.1 1 16C1 14.9 1.9 14 3 14C3.18 14 3.35 14.02 3.51 14.07L8.07 9.52C8.02 9.36 8 9.18 8 9C8 7.9 8.9 7 10 7C11.1 7 12 7.9 12 9C12 9.18 11.98 9.36 11.93 9.52L14.48 12.07C14.64 12.02 14.82 12 15 12C15.18 12 15.36 12.02 15.52 12.07L19.07 8.51C19.02 8.35 19 8.18 19 8C19 6.9 19.9 6 21 6C22.1 6 23 6.9 23 8Z"
        fill={fill}
      />
    </svg>
  );
}

function FlightLand(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5 19H3.5C2.95 19 2.5 19.45 2.5 20C2.5 20.55 2.95 21 3.5 21H20.5C21.05 21 21.5 20.55 21.5 20C21.5 19.45 21.05 19 20.5 19ZM3.51 11.61L19.34 15.85C20.14 16.06 20.96 15.59 21.18 14.79C21.39 13.99 20.92 13.17 20.12 12.95L14.81 11.53L12.23 3.08C12.12 2.72 11.84 2.45 11.48 2.35C10.8 2.17 10.13 2.68 10.13 3.39V10.27L5.15 8.95L4.4 7.09C4.28 6.8 4.04 6.58 3.73 6.5L3.4 6.41C3.08 6.32 2.77 6.56 2.77 6.89V10.64C2.77 11.1 3.07 11.49 3.51 11.61Z"
        fill={fill}
      />
    </svg>
  );
}

function ReplyAll(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.00001 7.56C7.00001 6.62 5.86001 6.14 5.19001 6.81L0.710011 11.29C0.320011 11.68 0.320011 12.31 0.710011 12.7L5.19001 17.18C5.86001 17.86 7.00001 17.38 7.00001 16.44C7.00001 16.16 6.89001 15.89 6.69001 15.69L3.00001 12L6.69001 8.31C6.89001 8.11 7.00001 7.84 7.00001 7.56ZM13 9V7.41C13 6.52 11.92 6.07 11.29 6.7L6.70001 11.29C6.31001 11.68 6.31001 12.31 6.70001 12.7L11.29 17.29C11.92 17.92 13 17.47 13 16.58V14.9C18 14.9 21.5 16.5 24 20C23 15 20 10 13 9Z"
        fill={fill}
      />
    </svg>
  );
}

function ArrowDropdownUp(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.70999 12.29L11.3 9.7C11.69 9.31 12.32 9.31 12.71 9.7L15.3 12.29C15.93 12.92 15.48 14 14.59 14H9.40999C8.51999 14 8.07999 12.92 8.70999 12.29Z"
        fill={fill}
      />
    </svg>
  );
}

function Search(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5 14H14.71L14.43 13.73C15.63 12.33 16.25 10.42 15.91 8.39C15.44 5.61 13.12 3.39 10.32 3.05C6.09002 2.53 2.53002 6.09 3.05002 10.32C3.39002 13.12 5.61002 15.44 8.39002 15.91C10.42 16.25 12.33 15.63 13.73 14.43L14 14.71V15.5L18.25 19.75C18.66 20.16 19.33 20.16 19.74 19.75C20.15 19.34 20.15 18.67 19.74 18.26L15.5 14ZM9.50002 14C7.01002 14 5.00002 11.99 5.00002 9.5C5.00002 7.01 7.01002 5 9.50002 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.50002 14Z"
        fill={fill}
      />
    </svg>
  );
}

function Kebab(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM12 16C10.9 16 10 16.9 10 18C10 19.1 10.9 20 12 20C13.1 20 14 19.1 14 18C14 16.9 13.1 16 12 16Z"
        fill={fill}
      />
    </svg>
  );
}

function Close(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.3 5.71C17.91 5.32 17.28 5.32 16.89 5.71L12 10.59L7.11 5.7C6.72 5.31 6.09 5.31 5.7 5.7C5.31 6.09 5.31 6.72 5.7 7.11L10.59 12L5.7 16.89C5.31 17.28 5.31 17.91 5.7 18.3C6.09 18.69 6.72 18.69 7.11 18.3L12 13.41L16.89 18.3C17.28 18.69 17.91 18.69 18.3 18.3C18.69 17.91 18.69 17.28 18.3 16.89L13.41 12L18.3 7.11C18.68 6.73 18.68 6.09 18.3 5.71Z"
        fill={fill}
      />
    </svg>
  );
}

function SocialApple(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3205 1C15.4483 2.09121 14.9879 3.16651 14.315 3.9569C13.6128 4.73499 12.4895 5.33013 11.3955 5.25348C11.2522 4.20348 11.8066 3.08696 12.4271 2.40578C13.1286 1.63274 14.3466 1.0405 15.3205 1ZM19.4706 8.6169C19.348 8.68567 17.3252 9.81995 17.3473 12.1328C17.3728 14.9263 19.9489 15.8498 19.9804 15.8599C19.9651 15.925 19.577 17.1926 18.6108 18.4798C17.8039 19.613 16.9585 20.7208 15.6158 20.741C14.9775 20.7548 14.5464 20.5824 14.0973 20.4028C13.6287 20.2154 13.1405 20.0201 12.3768 20.0201C11.567 20.0201 11.0571 20.2216 10.5654 20.416C10.1402 20.5841 9.72862 20.7468 9.14851 20.7692C7.86967 20.8134 6.89265 19.5594 6.05652 18.4364C4.38503 16.1434 3.08387 11.9745 4.82851 9.13764C5.67387 7.7463 7.21525 6.85035 8.86287 6.82648C9.58841 6.81255 10.2843 7.07517 10.8943 7.3054C11.3608 7.48146 11.7771 7.63857 12.118 7.63857C12.4175 7.63857 12.8222 7.48774 13.2938 7.31194C14.0369 7.0349 14.9465 6.69586 15.873 6.78744C16.5066 6.80479 18.3098 7.02246 19.4731 8.6155L19.4706 8.6169Z"
        fill={fill}
      />
    </svg>
  );
}

function Image(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 19V5C21 3.9 20.1 3 19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19ZM8.9 13.98L11 16.51L14.1 12.52C14.3 12.26 14.7 12.26 14.9 12.53L18.41 17.21C18.66 17.54 18.42 18.01 18.01 18.01H6.02C5.6 18.01 5.37 17.53 5.63 17.2L8.12 14C8.31 13.74 8.69 13.73 8.9 13.98Z"
        fill={fill}
      />
    </svg>
  );
}

function Movie(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 4L19.82 7.64C19.9 7.8 19.78 8 19.6 8H17.62C17.24 8 16.89 7.79 16.73 7.45L15 4H13L14.82 7.64C14.9 7.8 14.78 8 14.6 8H12.62C12.24 8 11.89 7.79 11.73 7.45L10 4H8L9.82 7.64C9.9 7.8 9.78 8 9.6 8H7.62C7.24 8 6.89 7.79 6.72 7.45L5 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V5C22 4.45 21.55 4 21 4H18Z"
        fill={fill}
      />
    </svg>
  );
}

function Settings(props) {
  const fill = props.fill || "#18214D";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.43 12.98C19.47 12.66 19.5 12.34 19.5 12C19.5 11.66 19.47 11.34 19.43 11.02L21.54 9.37C21.73 9.22 21.78 8.95 21.66 8.73L19.66 5.27C19.54 5.05 19.27 4.97 19.05 5.05L16.56 6.05C16.04 5.65 15.48 5.32 14.87 5.07L14.49 2.42C14.46 2.18 14.25 2 14 2H9.99999C9.74999 2 9.53999 2.18 9.50999 2.42L9.12999 5.07C8.51999 5.32 7.95999 5.66 7.43999 6.05L4.94999 5.05C4.71999 4.96 4.45999 5.05 4.33999 5.27L2.33999 8.73C2.20999 8.95 2.26999 9.22 2.45999 9.37L4.56999 11.02C4.52999 11.34 4.49999 11.67 4.49999 12C4.49999 12.33 4.52999 12.66 4.56999 12.98L2.45999 14.63C2.26999 14.78 2.21999 15.05 2.33999 15.27L4.33999 18.73C4.45999 18.95 4.72999 19.03 4.94999 18.95L7.43999 17.95C7.95999 18.35 8.51999 18.68 9.12999 18.93L9.50999 21.58C9.53999 21.82 9.74999 22 9.99999 22H14C14.25 22 14.46 21.82 14.49 21.58L14.87 18.93C15.48 18.68 16.04 18.34 16.56 17.95L19.05 18.95C19.28 19.04 19.54 18.95 19.66 18.73L21.66 15.27C21.78 15.05 21.73 14.78 21.54 14.63L19.43 12.98ZM12 15.5C10.07 15.5 8.49999 13.93 8.49999 12C8.49999 10.07 10.07 8.5 12 8.5C13.93 8.5 15.5 10.07 15.5 12C15.5 13.93 13.93 15.5 12 15.5Z"
        fill={fill}
      />
    </svg>
  );
}

function User(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 8C8 10.2091 9.79086 12 12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8ZM20 18C20 15.34 14.67 14 12 14C9.33 14 4 15.34 4 18V19C4 19.55 4.45 20 5 20H19C19.55 20 20 19.55 20 19V18Z"
        fill={fill}
      />
    </svg>
  );
}

function Plus(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
        fill={fill}
      />
    </svg>
  );
}

function Remove(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
        fill={fill}
      />
    </svg>
  );
}

function Apple(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3205 1C15.4483 2.09121 14.9879 3.16651 14.315 3.9569C13.6128 4.73499 12.4895 5.33013 11.3955 5.25348C11.2522 4.20348 11.8066 3.08696 12.4271 2.40578C13.1286 1.63274 14.3466 1.0405 15.3205 1ZM19.4706 8.6169C19.348 8.68567 17.3252 9.81995 17.3473 12.1328C17.3728 14.9263 19.9489 15.8498 19.9804 15.8599C19.9651 15.925 19.577 17.1926 18.6108 18.4798C17.8039 19.613 16.9585 20.7208 15.6158 20.741C14.9775 20.7548 14.5464 20.5824 14.0973 20.4028C13.6287 20.2154 13.1405 20.0201 12.3768 20.0201C11.567 20.0201 11.0571 20.2216 10.5654 20.416C10.1402 20.5841 9.72862 20.7468 9.14851 20.7692C7.86967 20.8134 6.89265 19.5594 6.05652 18.4364C4.38503 16.1434 3.08387 11.9745 4.82851 9.13764C5.67387 7.7463 7.21525 6.85035 8.86287 6.82648C9.58841 6.81255 10.2843 7.07517 10.8943 7.3054C11.3608 7.48146 11.7771 7.63857 12.118 7.63857C12.4175 7.63857 12.8222 7.48774 13.2938 7.31194C14.0369 7.0349 14.9465 6.69586 15.873 6.78744C16.5066 6.80479 18.3098 7.02246 19.4731 8.6155L19.4706 8.6169Z"
        fill={fill}
      />
    </svg>
  );
}

function GooglePlay(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.46394 2.11881L13.9131 12.0147L4.5093 21.9968C4.23488 21.8143 4.08777 21.4182 4.08528 20.9064C4.08056 19.9257 4.00569 4.35734 4.00005 3.18926C3.99743 2.62901 4.19174 2.28714 4.46394 2.11881ZM17.0292 8.70719L5.53896 2.13229C5.41624 2.06188 5.27686 2.01912 5.13801 2L14.3041 11.5997L17.0292 8.70719ZM17.5397 14.9886L14.6974 12.0119L17.5369 8.99788L21.4472 11.235C22.4106 11.7859 21.9178 12.4752 21.4472 12.7454L17.5397 14.9886ZM5.28822 22C5.36834 21.9684 5.45199 21.9281 5.53878 21.8783L17.0314 15.2804L14.3067 12.4269L5.28822 22Z"
        fill={fill}
      />
    </svg>
  );
}

function Check(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6138 6.21059C19.0498 6.54958 19.1285 7.17784 18.7895 7.61385L11.0145 17.6138C10.8414 17.8365 10.5822 17.9758 10.3009 17.9972C10.0197 18.0186 9.74242 17.9202 9.53757 17.7262L5.3125 13.7262C4.91144 13.3465 4.89412 12.7136 5.27382 12.3126C5.65351 11.9115 6.28644 11.8942 6.6875 12.2739L10.1122 15.5161L17.2105 6.38625C17.5495 5.95024 18.1778 5.87159 18.6138 6.21059Z"
        fill={fill}
      />
    </svg>
  );
}

function StarBorder(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.65 9.04L14.81 8.62L12.92 4.17C12.58 3.36 11.42 3.36 11.08 4.17L9.19 8.63L4.36 9.04C3.48 9.11 3.12 10.21 3.79 10.79L7.46 13.97L6.36 18.69C6.16 19.55 7.09 20.23 7.85 19.77L12 17.27L16.15 19.78C16.91 20.24 17.84 19.56 17.64 18.7L16.54 13.97L20.21 10.79C20.88 10.21 20.53 9.11 19.65 9.04ZM12 15.4L8.24 17.67L9.24 13.39L5.92 10.51L10.3 10.13L12 6.1L13.71 10.14L18.09 10.52L14.77 13.4L15.77 17.68L12 15.4Z"
        fill={fill}
      />
    </svg>
  );
}

function Security(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM12 17C10.9 17 10 16.1 10 15C10 13.9 10.9 13 12 13C13.1 13 14 13.9 14 15C14 16.1 13.1 17 12 17ZM9 8V6C9 4.34 10.34 3 12 3C13.66 3 15 4.34 15 6V8H9Z"
        fill={fill}
      />
    </svg>
  );
}

function Twitter(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.032 17C13.0696 17 16.372 11.6132 16.372 6.94228C16.372 6.78894 16.372 6.63646 16.3624 6.48484C17.0048 5.98518 17.5592 5.36492 18 4.65506C17.4016 4.94107 16.7656 5.12887 16.1152 5.21158C16.8 4.76964 17.3128 4.07529 17.5584 3.25603C16.9136 3.66781 16.2088 3.95813 15.4736 4.11406C14.2304 2.6909 12.1512 2.62198 10.8288 3.96071C9.9768 4.82391 9.6144 6.11096 9.8792 7.33856C7.24 7.19555 4.7808 5.85337 3.1136 3.64541C2.2424 5.26068 2.688 7.3265 4.1304 8.36371C3.608 8.34734 3.0968 8.19572 2.64 7.92178V7.96657C2.6408 9.64903 3.7424 11.098 5.2736 11.4314C4.7904 11.5736 4.2832 11.5942 3.792 11.4917C4.2216 12.9321 5.4544 13.9185 6.8584 13.9469C5.696 14.9307 4.26 15.4649 2.7816 15.4631C2.5208 15.4623 2.26 15.4459 2 15.4123C3.5016 16.4495 5.248 17 7.032 16.9974"
        fill={fill}
      />
    </svg>
  );
}

function LinkedIn(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 19H16.9231V13.3967C16.9231 11.8596 16.2715 11.0022 15.1031 11.0022C13.8315 11.0022 13.0769 11.8956 13.0769 13.3967V19H10V8.59243H13.0769V9.76288C13.0769 9.76288 14.0423 8 16.2177 8C18.3938 8 20 9.3818 20 12.2415C20 15.1004 20 19 20 19ZM5.50031 6C4.67151 6 4 5.32819 4 4.4997C4 3.67181 4.67151 3 5.50031 3C6.32849 3 7 3.67181 7 4.4997C7.00061 5.32819 6.32849 6 5.50031 6ZM4 19H7V9H4V19Z"
        fill={fill}
      />
    </svg>
  );
}

function Google(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.8751 8.60271H10.1479C10.1479 9.30231 10.1479 10.7015 10.1436 11.4011H14.0418C13.8925 12.1007 13.3628 13.0802 12.6145 13.5734C12.6138 13.5727 12.6131 13.5776 12.6116 13.5769C11.6167 14.2338 10.3037 14.3829 9.32881 14.187C7.80069 13.8833 6.59134 12.7752 6.10032 11.3675C6.10317 11.3654 6.10532 11.3459 6.10746 11.3445C5.80012 10.4714 5.80012 9.30231 6.10746 8.60271H6.10675C6.50272 7.31683 7.74851 6.14359 9.27878 5.82247C10.5096 5.56152 11.8983 5.84416 12.9197 6.79982C13.0555 6.6669 14.7995 4.96405 14.9303 4.82553C11.4409 1.66541 5.85373 2.77708 3.7631 6.85789H3.76239C3.76239 6.85789 3.7631 6.85789 3.75882 6.86558C2.72458 8.86996 2.76747 11.2318 3.76596 13.1404C3.7631 13.1425 3.76096 13.1438 3.75882 13.1459C4.66368 14.902 6.31045 16.2487 8.29458 16.7615C10.4024 17.3142 13.0848 16.9364 14.8817 15.3112C14.8824 15.3119 14.8831 15.3126 14.8838 15.3133C16.4062 13.9421 17.354 11.6061 16.8751 8.60271Z"
        fill={fill}
      />
    </svg>
  );
}

function Facebook(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.4914 21V12.79H16.4386L16.8807 9.58941H13.4914V7.54633C13.4914 6.61998 13.7655 5.98869 15.1883 5.98869L17 5.98799V3.12531C16.6867 3.08725 15.6112 3 14.3595 3C11.7456 3 9.9561 4.49127 9.9561 7.22935V9.58941H7V12.79H9.9561V21H13.4914Z"
        fill={fill}
      />
    </svg>
  );
}

function BluePlaceholder(props) {
  const fill = props.fill || "#6236FF";

  return (
    <svg
      width="255"
      height="340"
      viewBox="0 0 255 340"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="255" height="340" rx="8" fill={fill} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M124 166C124 168.209 125.791 170 128 170C130.209 170 132 168.209 132 166C132 163.791 130.209 162 128 162C125.791 162 124 163.791 124 166ZM136 176C136 173.34 130.67 172 128 172C125.33 172 120 173.34 120 176V177C120 177.55 120.45 178 121 178H135C135.55 178 136 177.55 136 177V176Z"
        fill="white"
      />
    </svg>
  );
}

function Star(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 17.27L17.17 20.39C17.55 20.62 18.02 20.28 17.92 19.85L16.55 13.97L21.11 10.02C21.44 9.73 21.27 9.18 20.82 9.14L14.81 8.63L12.46 3.09C12.29 2.68 11.71 2.68 11.54 3.09L9.19 8.63L3.18 9.14C2.74 9.18 2.56 9.73 2.9 10.02L7.46 13.97L6.09 19.85C5.99 20.28 6.46 20.62 6.84 20.39L12 17.27Z"
        fill={fill}
      />
    </svg>
  );
}

function Stars(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM15.22 17.39L12 15.45L8.78 17.39C8.4 17.62 7.93 17.28 8.03 16.85L8.88 13.19L6.05 10.74C5.72 10.45 5.9 9.9 6.34 9.86L10.08 9.54L11.54 6.09C11.71 5.68 12.29 5.68 12.46 6.09L13.92 9.53L17.66 9.85C18.1 9.89 18.28 10.44 17.94 10.73L15.11 13.18L15.96 16.85C16.06 17.28 15.6 17.62 15.22 17.39Z"
        fill={fill}
      />
    </svg>
  );
}

function ArrowForward(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.16634 10.8329H13.4747L10.2413 14.0663C9.91634 14.3913 9.91634 14.9246 10.2413 15.2496C10.5663 15.5746 11.0913 15.5746 11.4163 15.2496L16.0747 10.5913C16.3997 10.2663 16.3997 9.74128 16.0747 9.41628L11.4247 4.74961C11.0997 4.42461 10.5747 4.42461 10.2497 4.74961C9.92467 5.07461 9.92467 5.59961 10.2497 5.92461L13.4747 9.16628H4.16634C3.70801 9.16628 3.33301 9.54128 3.33301 9.99961C3.33301 10.4579 3.70801 10.8329 4.16634 10.8329Z"
        fill={fill}
      />
    </svg>
  );
}

function Lock(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM12 17C10.9 17 10 16.1 10 15C10 13.9 10.9 13 12 13C13.1 13 14 13.9 14 15C14 16.1 13.1 17 12 17ZM9 8V6C9 4.34 10.34 3 12 3C13.66 3 15 4.34 15 6V8H9Z"
        fill={fill}
      />
    </svg>
  );
}

function Phone(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.23 15.2598L16.69 14.9698C16.08 14.8998 15.48 15.1098 15.05 15.5398L13.21 17.3798C10.38 15.9398 8.06004 13.6298 6.62004 10.7898L8.47004 8.93977C8.90004 8.50977 9.11004 7.90977 9.04004 7.29977L8.75004 4.77977C8.63004 3.76977 7.78004 3.00977 6.76004 3.00977H5.03004C3.90004 3.00977 2.96004 3.94977 3.03004 5.07977C3.56004 13.6198 10.39 20.4398 18.92 20.9698C20.05 21.0398 20.99 20.0998 20.99 18.9698V17.2398C21 16.2298 20.24 15.3798 19.23 15.2598Z"
        fill={fill}
      />
    </svg>
  );
}

function VisibilityOff(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 6.49999C14.76 6.49999 17 8.73999 17 11.5C17 12.01 16.9 12.5 16.76 12.96L19.82 16.02C21.21 14.79 22.31 13.25 23 11.49C21.27 7.10999 17 3.99999 12 3.99999C10.73 3.99999 9.51 4.19999 8.36 4.56999L10.53 6.73999C11 6.59999 11.49 6.49999 12 6.49999ZM2.71 3.15999C2.32 3.54999 2.32 4.17999 2.71 4.56999L4.68 6.53999C3.06 7.82999 1.77 9.52999 1 11.5C2.73 15.89 7 19 12 19C13.52 19 14.97 18.7 16.31 18.18L19.03 20.9C19.42 21.29 20.05 21.29 20.44 20.9C20.83 20.51 20.83 19.88 20.44 19.49L4.13 3.15999C3.74 2.76999 3.1 2.76999 2.71 3.15999ZM12 16.5C9.24 16.5 7 14.26 7 11.5C7 10.73 7.18 9.99999 7.49 9.35999L9.06 10.93C9.03 11.11 9 11.3 9 11.5C9 13.16 10.34 14.5 12 14.5C12.2 14.5 12.38 14.47 12.57 14.43L14.14 16C13.49 16.32 12.77 16.5 12 16.5ZM14.97 11.17C14.82 9.76999 13.72 8.67999 12.33 8.52999L14.97 11.17Z"
        fill={fill}
      />
    </svg>
  );
}

function Favorite(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.35 20.13C12.59 20.82 11.42 20.82 10.66 20.12L10.55 20.02C5.3 15.27 1.87 12.16 2 8.28C2.06 6.58 2.93 4.95 4.34 3.99C6.98 2.19 10.24 3.03 12 5.09C13.76 3.03 17.02 2.18 19.66 3.99C21.07 4.95 21.94 6.58 22 8.28C22.14 12.16 18.7 15.27 13.45 20.04L13.35 20.13Z"
        fill={fill}
      />
    </svg>
  );
}

function Stats(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM8 17C7.45 17 7 16.55 7 16V11C7 10.45 7.45 10 8 10C8.55 10 9 10.45 9 11V16C9 16.55 8.55 17 8 17ZM12 17C11.45 17 11 16.55 11 16V8C11 7.45 11.45 7 12 7C12.55 7 13 7.45 13 8V16C13 16.55 12.55 17 12 17ZM16 17C15.45 17 15 16.55 15 16V14C15 13.45 15.45 13 16 13C16.55 13 17 13.45 17 14V16C17 16.55 16.55 17 16 17Z"
        fill={fill}
      />
    </svg>
  );
}

function Cart(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 18C5.9 18 5.01 18.9 5.01 20C5.01 21.1 5.9 22 7 22C8.1 22 9 21.1 9 20C9 18.9 8.1 18 7 18ZM1 3C1 3.55 1.45 4 2 4H3L6.6 11.59L5.25 14.03C4.52 15.37 5.48 17 7 17H18C18.55 17 19 16.55 19 16C19 15.45 18.55 15 18 15H7L8.1 13H15.55C16.3 13 16.96 12.59 17.3 11.97L20.88 5.48C21.25 4.82 20.77 4 20.01 4H5.21L4.54 2.57C4.38 2.22 4.02 2 3.64 2H2C1.45 2 1 2.45 1 3ZM17 18C15.9 18 15.01 18.9 15.01 20C15.01 21.1 15.9 22 17 22C18.1 22 19 21.1 19 20C19 18.9 18.1 18 17 18Z"
        fill={fill}
      />
    </svg>
  );
}

function GroupRounded(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM15.61 8.34C16.68 8.34 17.54 9.2 17.54 10.27C17.54 11.34 16.68 12.2 15.61 12.2C14.54 12.2 13.68 11.34 13.68 10.27C13.67 9.2 14.54 8.34 15.61 8.34ZM9.61 6.76C10.91 6.76 11.97 7.82 11.97 9.12C11.97 10.42 10.91 11.48 9.61 11.48C8.31 11.48 7.25 10.42 7.25 9.12C7.25 7.81 8.3 6.76 9.61 6.76ZM9.61 15.89V19.64C7.21 18.89 5.31 17.04 4.47 14.68C5.52 13.56 8.14 12.99 9.61 12.99C10.14 12.99 10.81 13.07 11.51 13.21C9.87 14.08 9.61 15.23 9.61 15.89ZM12 20C11.73 20 11.47 19.99 11.21 19.96V15.89C11.21 14.47 14.15 13.76 15.61 13.76C16.68 13.76 18.53 14.15 19.45 14.91C18.28 17.88 15.39 20 12 20Z"
        fill={fill}
      />
    </svg>
  );
}

function ArrowDropdownDown(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.71001 11.71L11.3 14.3C11.69 14.69 12.32 14.69 12.71 14.3L15.3 11.71C15.93 11.08 15.48 10 14.59 10H9.41001C8.52001 10 8.08001 11.08 8.71001 11.71Z"
        fill={fill}
      />
    </svg>
  );
}

function Nike(props) {
  const fill = props.fill || "#18214D";

  return (
    <svg
      width="50"
      height="18"
      viewBox="0 0 50 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.51554 17.9927C4.02613 17.9329 2.8069 17.5211 1.85402 16.7563C1.67229 16.6102 1.23864 16.1721 1.09344 15.9874C0.706907 15.4965 0.443447 15.0187 0.268447 14.4887C-0.270974 12.8571 0.00690997 10.716 1.06268 8.3662C1.96652 6.35446 3.36074 4.35921 5.79439 1.59583C6.15208 1.1892 7.21938 0 7.22708 0C7.229 0 7.17131 0.101785 7.09823 0.225729C6.46554 1.29614 5.9242 2.55698 5.629 3.64852C5.15497 5.39999 5.21266 6.90308 5.79631 8.06854C6.1992 8.87152 6.88958 9.56699 7.6665 9.95143C9.02611 10.6242 11.0165 10.6799 13.4463 10.1143C13.6136 10.0752 21.9059 7.85159 31.8741 5.17297C41.8423 2.49411 49.999 0.304067 50 0.305867C50.0029 0.308188 26.8424 10.3191 14.8184 15.5128C12.9146 16.335 12.4059 16.5426 11.5107 16.8601C9.22226 17.6718 7.17227 18.0592 5.51554 17.9927Z"
        fill={fill}
      />
    </svg>
  );
}

export {
  Card,
  Rotate,
  Stars,
  ArrowDropdownDown,
  VisibilityOff,
  Stats,
  Favorite,
  Plus,
  Check,
  Security,
  StarBorder,
  Apple,
  GooglePlay,
  Remove,
  TimeLine,
  Settings,
  Movie,
  Image,
  Kebab,
  ArrowDropdownUp,
  ReplyAll,
  FlightLand,
  Send,
  FavoriteBorder,
  Earth,
  Update,
  Explore,
  Alternate,
  Chat,
  Delete,
  ArrowRight,
  ChevronUp,
  Date,
  ArrowLeft,
  VisibilityOn,
  ChevronRight,
  DeleteForever,
  Bookmarks,
  Flight,
  Reply,
  Face,
  IconPlay,
  RightArrow,
  SprocketLogotypeLight,
  SprocketLogotypeDark,
  AppLogo,
  PlayRing,
  AppLogoBig,
  Network,
  DeleteOutline,
  SimpleLeftArrow,
  UserIcon,
  EmailIcon,
  SimpleRightArrow,
  Donut,
  Support,
  Location,
  Bookmark,
  Email,
  Assignment,
  Home,
  Basket,
  Extension,
  Group,
  AppStore,
  PlayMarket,
  Download,
  Block,
  Upload,
  Flash,
  Camera,
  Carousel,
  Dashboard,
  Clock,
  Document,
  Search,
  User,
  Twitter,
  LinkedIn,
  Google,
  BluePlaceholder,
  Star,
  SimpleLeftArrowCustom,
  ArrowForward,
  Lock,
  Phone,
  Facebook,
  Close,
  ChevronDown,
  ChevronLeft,
  Fire,
  Cart,
  Nike,
  FlashRounded,
  GroupRounded,
  SocialApple,
};
